{
  "setupCheck": {
    "button": "Setup",
    "title": "Setup",
    "count": "{n} to fix",
    "progress": "{ok} of {total} in order",
    "ok": "In order",
    "titles": {
      "contact_email_missing": "Contact email",
      "tax_number_missing": "Tax registration numbers",
      "hq_unlocated": "Headquarters",
      "no_job_types": "Job types",
      "type_without_crew": "Crews per type",
      "season_never_opened": "Season opening",
      "no_work_crew": "Work crew",
      "no_quote_crew": "Quote crew",
      "invitations_pending": "Invitations",
      "crew_without_member": "Crew members",
      "crew_without_type": "Crew job types",
      "crew_without_target": "Day targets",
      "technician_without_app": "Mobile app"
    },
    "lines": {
      "contact_email_missing": "No contact email",
      "tax_number_missing": "Tax charged with no registration number",
      "hq_unlocated": "Headquarters not located",
      "no_job_types": "No job type",
      "type_without_crew": "Type with no crew",
      "season_never_opened": "Season never opened, jobs waiting",
      "no_work_crew": "No work crew",
      "no_quote_crew": "No quote crew",
      "invitations_pending": "Invitation pending",
      "crew_without_member": "Crew with no member",
      "crew_without_type": "Crew with no type",
      "crew_without_target": "Crew with no day target",
      "technician_without_app": "Technician without the app"
    }
  },
  "units": {
    "ea": "ea",
    "hr": "hr",
    "day": "day",
    "ft": "ft",
    "m": "m",
    "sqft": "sq ft",
    "sqm": "sq m",
    "lb": "lb",
    "kg": "kg",
    "lot": "lot"
  },
  "auth": {
    "login": "Login",
    "logout": "Logout",
    "email": "Email Address",
    "password": "Password",
    "passwordConfirmation": "Confirm Password",
    "signIn": "Sign in",
    "oauthFailed": "The external sign-in did not go through. Try again or use your email.",
    "rememberMe": "Remember Me",
    "loginFailed": "Login failed",
    "emailPlaceholder": "Enter your email",
    "passwordPlaceholder": "Enter your password",
    "forgotPassword": "Forgot password?",
    "forgotPasswordTitle": "Reset your password",
    "forgotPasswordHint": "Enter your account email — we'll send you a reset link.",
    "sendResetLink": "Send the reset link",
    "resetEmailSent": "If an account exists for {email}, a reset link is on its way. Check your inbox.",
    "backToLogin": "Back to login",
    "resetPasswordTitle": "Choose a new password",
    "resetPasswordHint": "Pick a new password for your account.",
    "resetPasswordAction": "Change my password",
    "resetSuccess": "Password changed — log in with the new one.",
    "resetTokenMissing": "This reset link is invalid — request a new one.",
    "placeholders": {
      "password": "At least 8 characters",
      "passwordConfirmation": "Repeat your password"
    },
    "validation": {
      "passwordMin": "Password must be at least 8 characters",
      "passwordMatch": "The two passwords do not match"
    }
  },
  "dashboard": {
    "loading": "Loading...",
    "fieldDayCount": "1 stop today, {left} still to go | {count} stops today, {left} still to go",
    "fieldDayEmpty": "No stops today.",
    "stats": {
      "completedToday": "Done Today",
      "remaining": "Remaining"
    },
    "blockers": "What needs handling"
  },
  "profile": {
    "updateSuccess": "Profile updated successfully.",
    "fields": {
      "firstName": "First name",
      "lastName": "Last name"
    },
    "placeholders": {
      "firstName": "Jane",
      "lastName": "Tremblay"
    },
    "avatar": {
      "instructions": "Click or drag an image here to upload your avatar.",
      "errorImageOnly": "Please select a valid image file."
    }
  },
  "timeZones": {
    "newfoundland": "Newfoundland Time",
    "atlantic": "Atlantic Time",
    "eastern": "Eastern Time",
    "central": "Central Time",
    "saskatchewan": "Saskatchewan (no daylight saving)",
    "mountain": "Mountain Time",
    "pacific": "Pacific Time",
    "utc": "UTC"
  },
  "organizations": {
    "select": "Select an Organization",
    "choose": "Choose which organization you want to access:",
    "noneFound": "No organizations found.",
    "welcome": "Welcome",
    "pickToBegin": "Select your workspace to begin.",
    "createNew": "Or create a new one:",
    "createDescription": "Establish a new workspace for your team.",
    "current": "Current Organization: {name}",
    "settings": "Organization Settings",
    "switch": "Switch Organization",
    "updateSuccess": "Organization updated successfully.",
    "fields": {
      "name": "Organization Name",
      "billingEmail": "Stripe account email",
      "timeZone": "Time Zone",
      "hqAddress": "HQ address",
      "businessAddress": "Address printed on your documents",
      "maxServiceTravelMinutes": "Max travel from HQ (min)",
      "publicTagline": "Tagline",
      "rbqLicence": "RBQ licence",
      "publicPhone": "Public phone",
      "publicEmail": "Public email"
    }
  },
  "sectors": {
    "title": "Sectors",
    "served": "Served municipalities",
    "addNew": "Add a municipality",
    "add": "Add | Add {n} municipality | Add {n} municipalities",
    "none": "No sector",
    "empty": "No municipality",
    "emptyHint": "Add the municipalities you serve.",
    "fields": {
      "name": "Name"
    },
    "locationsCount": "no locations | {n} location | {n} locations",
    "unserved": "Waiting work outside your municipalities:",
    "reset": {
      "action": "Reset to the drive time",
      "confirmTitle": "Reset to the drive time?",
      "confirmDescription": "{added} · {removed}. Removed municipalities' locations stay, with no sector.",
      "added": "none added | {n} added | {n} added",
      "removed": "none removed | {n} removed | {n} removed",
      "summary": "{added} · {removed}",
      "upToDate": "The list already matches the drive time.",
      "unavailable": "Drive times are unavailable right now — try again shortly."
    },
    "alreadyAdopted": "Already served",
    "searchCatalog": "Browse or search the official catalog",
    "searchCatalogPlaceholder": "Filter by name — e.g. Lévis",
    "noResults": "No municipality found.",
    "level": {
      "municipality": "Municipality",
      "arrondissement": "Borough"
    },
    "viewMap": "View the zone on a map",
    "deleteConfirmTitle": "Remove this municipality?",
    "deleteConfirmDescription": "Locations in « {name} » stay, without a sector.",
    "createSuccess": "Municipality added.",
    "batchAdoptSuccess": "No new municipality (all already in place). | {n} municipality added. | {n} municipalities added.",
    "deleteSuccess": "Municipality removed.",
    "filterPlaceholder": "Filter by sector"
  },
  "serviceArea": {
    "outside": "Outside area (~{minutes} min)",
    "outsideNoEstimate": "Outside service area",
    "fromHq": "~{minutes} min from the depot",
    "hint": "Outside the organization's service area — informational only, never blocking"
  },
  "fieldBank": {
    "title": "Job bank",
    "pullButton": "Pull from the bank",
    "pullSuccess": "Job added to your day | Job added to your day | {count} jobs added to your day",
    "pullPartial": "{count} added · {dropped} were already taken",
    "pull": "Pull",
    "empty": "No flexible jobs waiting in the bank.",
    "emptyBorrow": "Nothing to bring forward for your day's types.",
    "searchPlaceholder": "Search a customer",
    "forCrew": "for {name}",
    "filters": {
      "types": "Types",
      "sector": "Sector"
    },
    "untitled": "Untitled visit",
    "untyped": "No type yet",
    "lens": {
      "capability": "My capability",
      "all": "Everything",
      "untyped": "No type"
    },
    "views": {
      "bank": "Bank",
      "other": "Bring forward"
    },
    "plannedOn": "Planned for {date}",
    "detour": "+{minutes} min",
    "bestAdd": "Best addition",
    "fill": "Fill the rest of the day",
    "fillNoBudget": "No day target — fill needs one to know where to stop.",
    "fillNothing": "Nothing in the bank fits what's left.",
    "crewPicker": {
      "title": "Whose day are you starting?",
      "hint": "You are on more than one crew, and none of them has a confirmed day yet."
    },
    "gauge": {
      "remaining": "{amount} left",
      "over": "Over by {amount}"
    },
    "noCrew": "You are not on a crew, so there is no day to pull onto. Ask dispatch.",
    "returnToBank": "Put back in the bank",
    "returnToBankConfirm": "Put it back",
    "returnedToBank": "Back in the bank — still owed, just not today"
  },
  "dayPlan": {
    "title": "My day plan",
    "summaryStops": "1 stop | {count} stops",
    "summaryDone": "{count} done | {count} done | {count} done",
    "summaryLeft": "{count} left | {count} left | {count} left",
    "dayOffHint": "the stops below have not been resolved yet"
  },
  "contacts": {
    "title": "Contacts",
    "createNew": "New Contact",
    "createNamed": "Create “{name}”",
    "editTitle": "Edit Contact",
    "createSuccess": "Contact created successfully.",
    "updateSuccess": "Contact updated successfully.",
    "deleteSuccess": "Contact deleted.",
    "deleteConfirmTitle": "Delete Contact?",
    "deleteConfirmDescription": "Are you sure you want to delete {name}? This action is irreversible.",
    "noContacts": "No contacts found.",
    "search": "Search contacts",
    "searchPlaceholder": "Search contacts",
    "deleteTitle": "Delete Client",
    "fields": {
      "firstName": "First Name",
      "lastName": "Last Name",
      "email": "Email Address",
      "phone": "Phone Number",
      "cellPhone": "Mobile (for texts)",
      "noSms": "No SMS contact",
      "jobTitle": "Job Title",
      "fullName": "Full Name",
      "company": "Company",
      "created": "Created"
    },
    "siteContactRole": "Site contact",
    "detailsTitle": "Contact Information"
  },
  "companies": {
    "title": "Companies",
    "createNew": "New Company",
    "editTitle": "Edit Company",
    "createSuccess": "Company created successfully.",
    "updateSuccess": "Company updated successfully.",
    "deleteSuccess": "Company deleted.",
    "deleteConfirmTitle": "Delete Company?",
    "deleteConfirmDescription": "Are you sure you want to delete {name}? Associated contacts will be unlinked and service locations will be deleted.",
    "noCompanies": "No companies found.",
    "searchPlaceholder": "Search companies",
    "people": {
      "title": "People",
      "empty": "No contacts linked to this company.",
      "link": "Link Contact",
      "unlink": "Unlink"
    },
    "fields": {
      "companyName": "Company Name",
      "email": "Email Address",
      "phone": "Phone Number",
      "website": "Website",
      "notes": "Notes",
      "created": "Created"
    },
    "detailsTitle": "Company Information",
    "deleteTitle": "Delete company"
  },
  "visits": {
    "title": "Visits",
    "nextVisit": "Your next visit",
    "todayList": "Today's stops",
    "emptyTodayTitle": "No visits today",
    "visitN": "Visit {position}",
    "visitOfTotal": "Visit {index} of {total}",
    "addVisit": "Add Visit",
    "removeVisit": "Remove Visit",
    "removeConfirm": "Remove this visit? This cannot be undone.",
    "lastVisitGuard": "A job must keep at least one visit.",
    "unscheduled": "Unscheduled",
    "flexibleUnscheduled": "Flexible — no time promise, waits in the bank",
    "toPlace": "To place",
    "chip": {
      "bank": "In the bank",
      "after": "After {title}",
      "previousStep": "the previous step",
      "toConfirm": "To contact"
    },
    "giveDate": "Set a date",
    "minutes": "{n} min",
    "markDone": {
      "action": "Mark done",
      "title": "Mark as done",
      "on": "When",
      "crew": "By",
      "noCrewHint": "Without a crew, the day is credited to nobody.",
      "submit": "Mark done"
    },
    "ladder": {
      "otherDayWarning": "This visit is scheduled for {date}, not today."
    },
    "sections": {
      "evaluation": "Evaluation",
      "work": "Work"
    },
    "createSuccess": "Visit created.",
    "updateSuccess": "Visit updated.",
    "confirmSuccess": "Visit confirmed — waiting for a date.",
    "unconfirmSuccess": "Agreement withdrawn.",
    "deleteSuccess": "Visit removed.",
    "statusUpdated": "Visit status updated.",
    "status": {
      "pending": "Pending",
      "scheduled": "Scheduled",
      "dispatched": "Dispatched",
      "working": "Working",
      "completed": "Completed",
      "skipped": "Skipped",
      "cancelled": "Cancelled"
    },
    "extra": {
      "badge": "Off-program",
      "menuTitle": "Presets — {type}",
      "free": "Blank visit",
      "presetHint": "{name} · prefilled from the type's preset — everything stays editable",
      "when": "When",
      "whenPlace": "To place",
      "whenDate": "Pick a date",
      "dueWithinShort": "within {days} d",
      "submit": "Add the visit"
    },
    "fields": {
      "name": "Name",
      "namePlaceholder": "e.g. First treatment (optional)",
      "instructions": "Instructions for the crew",
      "instructionsPlaceholder": "What the customer reported, what to redo, when they are home",
      "instructionsHint": "Shown on the stop, on the phone. Never copied from the preset.",
      "dueWithin": "Due by",
      "dueWithinHint": "The bank and the board place what is due first.",
      "scheduledAt": "Scheduled Time",
      "duration": "Duration",
      "durationMinutes": "Duration (minutes)",
      "status": "Status"
    },
    "window": {
      "section": "Re-treatment window",
      "sectionHint": "When this visit becomes due, measured from the previous visit.",
      "firm": "Firm window",
      "projected": "Projected window",
      "overdue": "Overdue",
      "dueRange": "Due {range}",
      "dueBy": "Due by {date}",
      "dueOn": "Due {date}",
      "overdueRange": "Overdue · {range}"
    },
    "deferredFrom": "Returned from {date}",
    "deferredHint": "Sent back to the pool when its day was closed — still owed.",
    "reservedFor": "Planned for {name}",
    "reservedForHint": "A crew was named on this visit — no automatic pick will hand it to another. You can still give it to whoever is covering.",
    "deferredStartedHint": "Started, never finished — sent back to the pool when its day was closed.",
    "draftPlacement": "Draft · {crew} · {date}",
    "draftPlacementHint": "Already dropped on a draft day — confirm or remove it before placing it elsewhere.",
    "flexible": {
      "label": "Flexible timing",
      "hint": "No time promise — the customer doesn't expect a call about when this happens.",
      "badge": "No time promise"
    },
    "kind": {
      "work": "Work",
      "evaluation": "Evaluation",
      "evaluationHint": "A sales look-see — never counted as work value; completing it marks the job assessed."
    },
    "actions": {
      "dispatch": "Dispatch",
      "startWork": "Start Work",
      "complete": "Complete",
      "completeEvaluation": "Finish evaluation",
      "finishVisit": "Finish visit",
      "skip": "Skip",
      "confirm": "Put in the bank",
      "unconfirm": "Take out of the bank",
      "cancel": "Cancel"
    },
    "timeline": {
      "added": "Visit {position} added",
      "removed": "Visit {position} removed",
      "statusChanged": "Visit {position} → {to}",
      "assigned": "{name} assigned to visit {position} as {kind}",
      "unassigned": "{name} unassigned from visit {position}",
      "squadAssigned": "Squad \"{name}\" assigned to visit {position}",
      "bankPulled": "Pulled from the bank",
      "bankPulledOn": "Pulled from the bank for {date}",
      "crewStamped": "Team “{name}” recorded on visit {position} (work started)",
      "crewStampedSelf": "Technician recorded on visit {position} (work started)"
    },
    "confirmActionDescription": "Confirm that you want to {action} for this visit.",
    "seasonLapsed": "Season closed",
    "seasonLapsedHint": "This work was owed inside a season that has since closed. It is still owed, but the composer no longer places it and it no longer counts as overdue.",
    "composeWindow": {
      "waiting": "Not yet",
      "passed": "Window over",
      "waitingHint": "Its job type's range has not started: the composer and the fills do not propose it yet. It can be placed by hand.",
      "passedHint": "Its job type's range is over: the composer and the fills no longer propose it. Still owed, placeable by hand."
    },
    "face": {
      "saved": "Saved · {field}",
      "notSaved": "Not saved — check the value",
      "durationOther": "other",
      "positiveMinutes": "A whole number of minutes",
      "wholeDays": "A whole number of days",
      "intervalMin": "Earliest (days)",
      "intervalMax": "Latest (days)",
      "crew": "Crew",
      "instructions": "Instructions",
      "delay": "Timing",
      "daysAfter": "days after {title}",
      "previousVisit": "the previous visit",
      "between": "between {from} and {to}",
      "from": "from {date}",
      "until": "by {date}",
      "byHand": "set by hand",
      "recompute": "Recompute"
    },
    "door": {
      "changeDate": "Change the date",
      "backToBank": "Put back in the bank",
      "seeBoard": "See on the board",
      "confirmedDay": "On a confirmed day",
      "freeDay": "Not on a confirmed day"
    },
    "retire": {
      "label": "Withdraw the visit",
      "skip": "Not needed this time",
      "cancel": "The customer cancels"
    },
    "awaiting": {
      "short": "Waiting",
      "hint": "The previous step of the program has no date yet. The composer won't place this one before it."
    }
  },
  "jobs": {
    "title": "Jobs",
    "kind": "Role",
    "deleteSuccess": "Job deleted.",
    "live": "Live",
    "myJobs": "My Jobs",
    "allJobs": "All Jobs",
    "nextJob": "Your Next Job",
    "urgentService": "Urgent Service Call",
    "emptyTitle": "No Jobs for Today",
    "serviceHistory": "Service History",
    "noHistory": "No previous jobs found for this client.",
    "createSuccess": "Job created successfully.",
    "leadCreated": "Lead created.",
    "createdToast": {
      "open": "Open the job",
      "dealConfirmed": "Sale confirmed.",
      "evaluationFirm": "Evaluation booked.",
      "evaluationBank": "Evaluation sent to the bank."
    },
    "statusUpdated": "Job status updated.",
    "noType": "No type",
    "typeUpdated": "Job type updated.",
    "planMultipleVisits": "Plan multiple visits",
    "deleteConfirmTitle": "Delete Job?",
    "deleteConfirmDescription": "This will permanently cancel and remove this job record.",
    "selectSquad": "Assign Squad (Optional)",
    "noSquad": "No Squad (Manual Assignment)",
    "status": {
      "title": "Status",
      "open": "Open",
      "assessed": "Assessed",
      "approved": "Approved",
      "completed": "Completed",
      "invoiced": "Billing open",
      "paid": "Paid",
      "cancelled": "Cancelled",
      "lost": "Lost"
    },
    "selectLocation": "Service Location",
    "locationStep": "Where is the job?",
    "fields": {
      "scheduledAt": "Scheduled Time",
      "scheduledFor": "Scheduled For",
      "unscheduled": "Unscheduled",
      "scheduled": "Scheduled",
      "created": "Created",
      "customer": "Customer",
      "title": "Title",
      "description": "Description",
      "jobType": "Job type",
      "dossier": "Job",
      "nextVisit": "Next visit",
      "skipProposal": "No proposal required",
      "skipProposalHint": "For warranty callbacks or internal work",
      "promisedWindow": "Promised window"
    },
    "timeline": {
      "title": "Timeline",
      "noEvents": "No events recorded yet.",
      "loadMore": "Load more",
      "system": "System",
      "created": "Job {ref} created",
      "statusChanged": "Status → {to}",
      "assigned": "{name} assigned as {kind}",
      "unassigned": "{name} unassigned",
      "squadAssigned": "Squad \"{name}\" assigned",
      "underpricedMarked": "Price judged too low for this work",
      "underpricedCleared": "“Price too low” mark removed",
      "paymentFirstEnabled": "Payment before work turned on",
      "paymentFirstDisabled": "Payment before work turned off",
      "createdGrouped": "Created for a grouped quote",
      "createdGroupedPaper": "Created for quote {paper}",
      "createdForfait": "Created for the bundle “{offer}”",
      "createdForfaitPaper": "Created for bundle {paper}",
      "createdRenewal": "Job {ref} created — renewal",
      "createdRenewalPaper": "Renewed with bundle {paper}",
      "createdRenewalOption": "Created for renewal option {paper}",
      "createdFrom": "{label}, from {origin}",
      "renewed": "Renewed · {child}",
      "renewedPaper": "Renewed · {child} (bundle {paper})",
      "leftBehind": "Not renewed — {reason}",
      "leftBehindPaper": "Not renewed with bundle {paper} — {reason}",
      "leftBehindReason": {
        "dead": "Job closed",
        "not_sold": "Never sold",
        "declined_forever": "Never again",
        "skip_proposal": "Sold without a quote",
        "renewed": "Already renewed",
        "declined_year": "Not this year",
        "type_unlinked": "Type removed from the season"
      },
      "declinedYear": "Not in {season}",
      "declinedYearPlain": "Not this year",
      "declinedForever": "Never renewed again",
      "declineUndoneYear": "Refusal lifted — {season}",
      "declineUndoneYearPlain": "Refusal lifted — not this year",
      "declineUndoneForever": "Refusal lifted — never again",
      "seeAll": "See all"
    },
    "postits": {
      "jobNote": "Job note",
      "empty": "No note"
    },
    "actions": {
      "dispatch": "Dispatch",
      "start": "Start Working",
      "complete": "Complete Job",
      "lose": "Mark as Lost",
      "cancel": "Cancel Job",
      "startNavigation": "Start Navigation",
      "navigate": "Navigate",
      "openJob": "Open the job",
      "viewReceipt": "View Receipt",
      "reschedule": "Reschedule",
      "unskipProposal": "A proposal after all",
      "renew": "Renew"
    },
    "deals": {
      "section": "Open files",
      "stage": {
        "signed": "Signed",
        "pending": "Awaiting",
        "drafted": "Draft",
        "evaluated": "Evaluated",
        "lead": "Lead"
      },
      "none": "No open file",
      "newJob": "New job",
      "acceptedProposal": "Accepted proposal",
      "submitWin": "Confirm the work",
      "submitAccept": "Accept and book",
      "submitAcceptOnly": "Accept the quote",
      "paperUnpriced": "unpriced lines",
      "pickPaper": "Which quote did the customer accept?"
    },
    "agreement": {
      "section": "How much?",
      "template": "Standard proposal",
      "templateFor": "Proposal for {type}",
      "templateNoType": "No job type picked",
      "templateNone": "No standard proposal defined",
      "templateNoneFor": "No standard proposal for {type}",
      "priced": "Agreed amount",
      "noProposal": "No proposal",
      "labelField": "Line label",
      "amountField": "Amount before tax ($)",
      "taxableLabel": "Taxable (GST/QST)",
      "descriptionField": "Description",
      "totalBeforeTax": "Total before tax",
      "amountRequired": "Enter the agreed amount, or choose \"No proposal\".",
      "pickOffer": "Which quote?"
    },
    "cancelConfirmDescription": "This will cancel the job. The record will be preserved for reference.",
    "loseConfirmDescription": "Mark this job as lost. Use this when the customer has declined the proposal and no further work will be done.",
    "dispatchBoard": {
      "tabs": {
        "all": "All",
        "open": "Open",
        "pipeline": "Pipeline",
        "done": "Done",
        "cancelled": "Cancelled"
      },
      "searchPlaceholder": "Search jobs"
    },
    "deletePermanently": "Delete Permanently",
    "keepJob": "Keep Job",
    "yesProceed": "Yes, Proceed",
    "noTimeScheduled": "No Time Scheduled",
    "customerInformation": "Customer Information",
    "unknownContact": "Unknown Contact",
    "assignees": "Assignees",
    "addAssignee": "Add Assignee",
    "team": "Team",
    "selectAssignee": "Select assignee",
    "role": "Role",
    "trade": "Trade",
    "removeAssignee": "Remove",
    "kinds": {
      "undefined": "Undefined",
      "lead": "Lead",
      "assistant": "Assistant",
      "supervisor": "Supervisor",
      "technician": "Technician",
      "dispatcher": "Dispatcher"
    },
    "trades": {
      "general": "General",
      "electrical": "Electrical",
      "plumbing": "Plumbing",
      "hvac": "HVAC",
      "gas": "Gas",
      "mechanical": "Mechanical",
      "roofing": "Roofing",
      "carpentry": "Carpentry",
      "painting": "Painting",
      "flooring": "Flooring",
      "concrete": "Concrete",
      "masonry": "Masonry",
      "landscaping": "Landscaping",
      "irrigation": "Irrigation",
      "fire_protection": "Fire Protection",
      "security": "Security",
      "low_voltage": "Low Voltage",
      "cleaning": "Cleaning",
      "pest_control": "Pest Control",
      "pool": "Pool",
      "snow_removal": "Snow Removal"
    },
    "technicians": "Technicians",
    "techniciansOptional": "Technicians (Optional)",
    "selectTechnicians": "Select technicians",
    "onePersonSelected": "1 person selected",
    "multiplePeopleSelected": "{count} people selected",
    "workDescription": "Work Description",
    "buildProposal": "Build Proposal",
    "viewProposal": "View Proposal",
    "awaitingDecision": "Awaiting",
    "confirmStatusTitle": "{action}",
    "confirmStatusDescription": "Confirm that you want to {action} for this job.",
    "sort": {
      "placeholder": "Sort by",
      "scheduledNewest": "Scheduled (Newest First)",
      "scheduledOldest": "Scheduled (Oldest First)",
      "createdNewest": "Created (Newest First)",
      "createdOldest": "Created (Oldest First)",
      "status": "Status"
    },
    "cancelConfirmTitle": "Cancel this job?",
    "underpriced": {
      "verb": "Price too low for this work",
      "unverb": "remove",
      "mark": "Price judged too low",
      "byOn": "by {name}, on {date}",
      "on": "on {date}",
      "by": "by {name}",
      "toast": "Marked “price too low”. The renewal will propose a new price.",
      "untoast": "Mark removed."
    },
    "renewOnDone": {
      "title": "Same thing next year?",
      "description": "The work is done. Is the customer renewing for {label}?",
      "year": "For which year?",
      "yes": "Yes — renew for {label}",
      "no": "No — not for {label}",
      "absent": "Customer absent, we will call"
    },
    "loseConfirmTitle": "Mark as lost?",
    "editTitle": "Edit Job",
    "updateSuccess": "Job updated.",
    "editTitleAction": "Edit title",
    "addDescriptionAction": "Add a note",
    "typeLocked": "Type locked — the visit program and completed work derive from it.",
    "searchPlaceholder": "Search jobs",
    "filter": {
      "all": "All",
      "active": "Active",
      "done": "Done",
      "cancelled": "Cancelled",
      "leads": "Leads"
    },
    "assignSquad": "Assign a team",
    "intake": {
      "next": "What's next",
      "createAndOpen": "Create and open",
      "cards": {
        "lead": { "label": "Lead", "caption": "Nothing decided" },
        "evaluation": { "label": "Evaluation", "caption": "Someone must go see" },
        "quote": { "label": "Quote", "caption": "To write, no visit" },
        "won": { "label": "Sold", "caption": "The customer said yes" }
      }
    },
    "quickCapture": {
      "addNote": "Note",
      "sectionWhen": "When?",
      "typePlaceholder": "Search a type",
      "untitled": "New job"
    },
    "program": {
      "title": "Planned program",
      "onSignature": "on signature",
      "hint": "Preview from the work type — these visits are created when the quote is signed.",
      "interval": "+{min}–{max} d",
      "intervalExact": "+{days} d"
    },
    "preciseAssignees": "Assign specific people",
    "preciseAssigneesHint": "Instead of the team — the exception",
    "whoGoes": "Who goes?",
    "leadGuard": {
      "title": "A quote is already underway at this address",
      "continue": "Continue on that job",
      "branch": "New linked job",
      "linked": "Linked to that job’s evaluation"
    },
    "createdBy": "created by {name}",
    "steps": {
      "evaluation": "Evaluation",
      "noEvaluation": "No evaluation",
      "noEvaluationShort": "None",
      "evaluationDone": "Done",
      "signed": "Signed",
      "sent": "Sent",
      "paidChip": "Paid",
      "invoicedChip": "Invoiced",
      "balanceDue": "Balance due {amount}",
      "proposal": "Quote",
      "work": "Work",
      "invoice": "Invoice",
      "addPhoto": "+ photo",
      "allPhotos": "all {n}",
      "dropPhotos": "Drop photos here",
      "wonVerbal": "Mark as sold",
      "visitsDone": "{n} visit | {n} visits",
      "visitsProgress": "{done} of {total} done",
      "lastOn": "last on {date}",
      "atSignature": "At signing",
      "program": "Program",
      "asNeeded": "As needed",
      "columns": {
        "visit": "Visit",
        "when": "When",
        "crew": "Crew",
        "duration": "Duration"
      },
      "photosTitle": "Photos",
      "addInvoice": "+ invoice",
      "addVisit": "+ visit",
      "addVisitFull": "+ Add a visit",
      "anotherOption": "+ Another option",
      "addWork": "+ Add work",
      "optionLetter": "Option {letter}",
      "groupedSheet": "Grouped quote",
      "signedOn": "signed on {date}",
      "openSheetPage": "Open its page",
      "unpricedLines": "{n} line without a price | {n} lines without a price",
      "confirmSaleDescription": "Quote {number} will be accepted on the customer's behalf.",
      "deleteDraftDescription": "Delete “{name}”? Nobody has seen it."
    },
    "noDescription": "No description.",
    "keys": {
      "navigate": "Directions",
      "photos": "Photos"
    },
    "notes": {
      "title": "Notes",
      "add": "+ note",
      "write": "Write a note",
      "placeholder": "Note… {'@'} to mention",
      "onJob": "The job",
      "photo": "+ photo",
      "publish": "Publish",
      "all": "all {n}",
      "seeOthers": "See the other note | See the {n} other notes",
      "noMembers": "No members",
      "unknownMember": "member",
      "systemAuthor": "System",
      "visitAction": "Note",
      "deleteTitle": "Delete the note",
      "deleteDescription": "The note is removed from the job. Its photos stay in the gallery."
    },
    "atAddress": {
      "heading": "Other jobs at this address",
      "children": "Created from this job",
      "newHere": "New job here",
      "newHereField": "Another job at this address",
      "sameOrigin": "same origin",
      "more": "+ {n} more | + {n} more",
      "fewer": "Show fewer"
    },
    "originJob": {
      "line": "From {ref} · {type}",
      "lineUntyped": "From {ref}"
    },
    "season": {
      "label": "Season",
      "change": "change",
      "idle": "waiting for the opening",
      "closed": "season closed",
      "updated": "Season updated",
      "none": "No season",
      "evaluationHeld": "Evaluation waiting for the season to open"
    },
    "paymentFirst": {
      "label": "Payment before work",
      "held": "Waiting for payment",
      "lockedHint": "Can no longer change: the work is paid for, done or closed",
      "enabled": "Payment before work turned on",
      "disabled": "Payment before work turned off",
      "applyToCustomer": "Also for {name}'s next jobs",
      "appliedToCustomer": "{name} will pay before the work from now on",
      "customerLabel": "Payment before work on their next jobs",
      "customerSaved": "Payment preference saved"
    },
    "renew": {
      "for": "Renew for {label}",
      "otherSeasons": "Other seasons",
      "toast": "Renewed for {label}",
      "toastPlain": "Renewed",
      "dialogTitle": "Renew {label}",
      "notBefore": "Not before",
      "declined": "Will not be renewed",
      "declinedYear": "Not renewed for {year}",
      "reconsider": "undo",
      "reconsidered": "Renewal possible again"
    },
    "noun": {
      "lead": "Lead",
      "dossier": "File",
      "job": "Work"
    },
    "stage": {
      "evaluation_agreed": "Agreed — to place",
      "lead": "Lead",
      "evaluation_booked": "Evaluation booked",
      "open": "Open",
      "to_quote": "To quote",
      "awaiting": "Awaiting signature",
      "to_plan_work": "To schedule",
      "signed_to_plan": "Signed — to schedule",
      "work_in_bank": "Work in the bank",
      "work_planned": "Work scheduled",
      "completed": "Completed",
      "invoiced": "Billing open",
      "paid": "Paid",
      "lost": "Lost",
      "cancelled": "Cancelled"
    },
    "coverage": {
      "title": "This proposal covers"
    },
    "generate": {
      "title": "This proposal will cover",
      "subtitle": "One section per job, one document, one signature.",
      "destination": "Destination",
      "newProposal": "New proposal",
      "mode": {
        "work": "From the work",
        "priced": "Agreed amount"
      },
      "addToThis": "Add to this proposal",
      "onDocument": "on {number}",
      "alreadyOnDraft": "already on the document",
      "noOffer": "no offer",
      "addWork": "+ Add work",
      "newJob": "new job",
      "removeAdded": "Remove",
      "inForfait": "in the bundle “{offer}”",
      "forfaitBlocked": {
        "onPaper": "{label} is already on this document",
        "sold": "{label} is already sold at this address"
      },
      "visitCount": "no visit | 1 visit | {count} visits",
      "footerCount": "{location} · {count} open jobs",
      "submit": "Generate",
      "addSections": "Nothing to add | Add 1 section | Add {count} sections",
      "toast": "{number} — one section per ticked job"
    },
    "proposals": {
      "proposed": "Offered",
      "priceMissing": "a price is missing",
      "emptyDraft": "empty draft · resume",
      "generate": "Generate",
      "send": "Send",
      "sendTitle": "Send to the customer",
      "delete": "Delete this draft",
      "deleteConfirm": "Delete « {name} »? Nobody has seen it.",
      "sendCount": "Send ({count})",
      "emailHint": "By email to {email}",
      "noEmailHint": "No email on file — the link will be yours to copy",
      "notRetained": "Not retained ({count})",
      "signedOn": "Signed on {date}",
      "toast": {
        "sent": "{count} quote sent | {count} quotes sent",
        "noEmail": "Sent — no email on file, copy the link for the customer"
      }
    }
  },
  "squads": {
    "title": "Teams",
    "subtitle": "Manage your standing teams and their truck.",
    "createNew": "New team",
    "noSquads": "No teams defined yet.",
    "addMember": "Add a member",
    "addPerson": "Add a person",
    "membersCount": "{count} members | {count} member | {count} members",
    "lead": "Team lead",
    "deleteConfirmTitle": "Delete team?",
    "deleteConfirmDescription": "Are you sure you want to delete {name}?",
    "fields": {
      "name": "Team name",
      "namePlaceholder": "e.g. Plumbing Team A",
      "vehicle": "Truck",
      "vehiclePlaceholder": "Select a truck",
      "startDepot": "Starts from",
      "startDepotPlaceholder": "HQ (default)",
      "endDepot": "Ends at",
      "endDepotPlaceholder": "Open route (no return)",
      "workLane": "Work",
      "quoteLane": "Quotes",
      "workTypes": "Types treated",
      "quoteTypes": "Types quoted",
      "noTypes": "No type",
      "addType": "Add a type",
      "unitMoney": "$",
      "unitStops": "stops",
      "evaluationsPerDay": "evaluations / day"
    },
    "sections": {
      "work": "What this team does"
    },
    "hours": {
      "from": "From",
      "to": "To",
      "break": "Break",
      "breakUnit": "min",
      "breakTooLong": "The break must be shorter than the workday."
    },
    "searchPlaceholder": "Search teams"
  },
  "templates": {
    "title": "Job types",
    "addNew": "New job type",
    "searchPlaceholder": "Search job types",
    "noTemplates": "No job types yet.",
    "createNamed": "Create the type “{name}”",
    "programTodo": "Program to define",
    "columns": {
      "todo": "To settle"
    },
    "createSuccess": "Job type created.",
    "updateSuccess": "Job type updated.",
    "deleteSuccess": "Job type deleted.",
    "stepAdded": "Visit added.",
    "stepUpdated": "Visit updated.",
    "stepRemoved": "Visit removed.",
    "deleteConfirmTitle": "Delete job type?",
    "deleteConfirmDescription": "Delete \"{name}\"? Existing jobs are unaffected.",
    "steps": "Visits",
    "visits": {
      "title": "Visits",
      "asNeeded": "As needed",
      "addAsNeeded": "Add an as-needed visit",
      "gapTo": "to",
      "gapLater": "days later",
      "noWindow": "No window",
      "none": "No visit",
      "program": "Program",
      "columns": {
        "visit": "Visit",
        "window": "Window",
        "duration": "Duration"
      },
      "dueWithin": "within",
      "days": "days"
    },
    "proposalTemplate": {
      "blankQuantityHint": "Empty = measured on site",
      "blankQuantityPlaceholder": "To measure",
      "catalogPriceNow": "Catalog price today: {amount}",
      "notFound": "Template not found"
    },
    "appearance": {
      "title": "Appearance",
      "color": "Colour",
      "auto": "Auto",
      "autoLabel": "Automatic",
      "customLabel": "Custom"
    },
    "evaluation": {
      "title": "Evaluation",
      "duration": "Time on site",
      "durationPlaceholder": "Optional",
      "fee": "Fee",
      "feePlaceholder": "Free",
      "quoteMode": "Quote",
      "afterVisit": "After a visit",
      "fromOffice": "From the office"
    },
    "extraVisits": {
      "added": "Visit added.",
      "updated": "Visit updated.",
      "removed": "Visit removed.",
      "fields": {
        "dueWithinDays": "Due within (days)"
      }
    },
    "addStep": "Add visit",
    "fields": {
      "name": "Name",
      "namePlaceholder": "e.g. Pest control — 3 applications",
      "description": "Description",
      "descriptionPlaceholder": "What this program covers",
      "stepName": "Visit name",
      "intervalMin": "Earliest (days)",
      "intervalMax": "Latest (days)",
      "duration": "Duration (min)"
    },
    "builder": {
      "startDate": "Start date",
      "recent": "Recent job types",
      "manage": "Manage job types",
      "empty": "No job types yet — create one first."
    },
    "crews": {
      "title": "Crews",
      "laneWork": "Work",
      "laneQuotes": "Quotes",
      "add": "Add a crew",
      "none": "No crew",
      "ranked": "Priority",
      "dropHere": "Drag a crew here",
      "unranked": "No priority",
      "rank": "Priority {n}"
    },
    "proposalTemplates": {
      "title": "Quote models",
      "add": "New model",
      "namePlaceholder": "Name (e.g. Standard trim)",
      "rename": "Rename",
      "delete": "Delete this model",
      "deleteConfirm": "Delete \"{name}\" and all of its lines? Quotes already written from this model are untouched.",
      "empty": "No model yet — a job of this type starts from a blank quote."
    }
  },
  "planning": {
    "title": "Planning",
    "standingDay": {
      "title": "This day's start & hours",
      "subtitle": "Override the crew's usual depot and hours for this day only.",
      "hint": "This applies to this plan only. Re-run « Suggest order » afterwards to re-time it.",
      "edit": "This day's start & hours",
      "startDepot": "Starts from",
      "endDepot": "Ends at",
      "hqDefault": "HQ (default)",
      "openRoute": "Open route (no return)",
      "window": "Working window",
      "start": "Start",
      "end": "End",
      "break": "Break",
      "breakUnit": "min",
      "endAfterStart": "The end must be after the start.",
      "breakTooLong": "The break must be shorter than the workday.",
      "saved": "This day's start & hours updated."
    },
    "filterByType": "Filter by type",
    "lens": {
      "types": "Types",
      "allWork": "All work",
      "allQuotes": "All quotes",
      "workPrefix": "Work",
      "quotesPrefix": "Quotes"
    },
    "stopsCount": "no stops | {n} stop | {n} stops",
    "cellRung": {
      "proposed": "Proposed",
      "draft": "Draft",
      "unclosed": "{count} to close out"
    },
    "revise": {
      "action": "Edit the day",
      "hint": "The day goes back to a draft. Nothing changes for the customer until you confirm it again.",
      "toast": "The day is back to a draft — confirm it again when it suits you.",
      "addTitle": "Edit the day?",
      "addDescription": "This day is promised. Adding a stop reopens it as a draft: the promised stops are carried over as they are, and nothing changes for the customer until you confirm it again.",
      "addConfirm": "Edit the day",
      "abandon": "Discard the changes",
      "abandonTitle": "Discard the changes?",
      "abandonDescription": "Your additions and the order you gave are lost, and the confirmed day takes its place again. Stops you removed are already back in the bank: discarding does not bring them back.",
      "abandonConfirm": "Discard",
      "abandonToast": "Changes discarded.",
      "addedStop": "Added to this day"
    },
    "collapseRow": "Collapse this row",
    "crewRow": {
      "perDay": "{value} / day"
    },
    "expandRow": "Expand this row",
    "collapseAll": "Collapse all rows",
    "expandAll": "Expand all rows",
    "viewMap": "View the day on a map",
    "today": "Today",
    "weekOf": "Week of {date}",
    "territoryMap": "Map",
    "availability": {
      "titleScheduleWork": "Schedule work",
      "book": "Book",
      "jobValue": "Quoted value: {amount}",
      "jobValueTypical": "Type's typical value (~)",
      "willDatePending": "the waiting visit will be dated",
      "willRedateCommitted": "already promised for {date} — this re-dates it",
      "willCreateVisit": "a work visit will be created",
      "bookedFirmToast": "Work booked — week of {date}",
      "bookedFlexibleToast": "Work booked — window {from} to {to}, waiting in the bank",
      "bookedBankToast": "Work sent to the bank — the Composer will place it",
      "viewWeek": "View week"
    },
    "reserve": {
      "subtitle": "Send the work to the bank — the Composer builds it into a day — or set a firm appointment."
    },
    "planEvaluation": {
      "title": "Book an evaluation",
      "openLeads": "Open leads",
      "newLead": "New lead",
      "untypedLead": "No type",
      "leadBooked": "evaluation booked for {date}",
      "leadAge": "opened today | opened {n} day ago | opened {n} days ago",
      "willBook": "Books this customer's waiting evaluation",
      "willCreate": "Creates the evaluation for this customer",
      "submit": "Book",
      "submitBank": "Send to the bank",
      "submitFirm": "Set the appointment",
      "alreadyInBank": "Already in the bank"
    },
    "deadlines": {
      "due": "{count} window closing · {amount} | {count} windows closing · {amount}"
    },
    "priority": {
      "late": "{count} late · {amount}",
      "next": "Next:",
      "dueOn": "due {date}",
      "toSchedule": "{n} signed to schedule | {n} signed to schedule",
      "toQuote": "{n} to quote | {n} to quote",
      "empty": "Nothing late, no windows closing soon."
    },
    "mode": {
      "operations": "Operations",
      "sales": "Sales"
    },
    "pipelineView": {
      "searchPlaceholder": "Search customer",
      "typesPlaceholder": "Job type"
    },
    "confirm": "Confirm",
    "overCapacity": "Over by {minutes} min",
    "discardDraft": "Discard draft",
    "discardTitle": "Discard this draft plan?",
    "discardDescription": "The suggestion is deleted; nothing was written to the visits. You can re-solve at any time.",
    "status": {
      "draft": "Draft",
      "confirmed": "Confirmed"
    },
    "receipt": {
      "evaluated": "Assessed",
      "noOutcome": "no outcome",
      "deferred": "Deferred",
      "openJob": "Open the job",
      "emptyDay": "Nothing to show for this day.",
      "done": "Done {value}",
      "target": "Target {value}"
    },
    "closures": {
      "tab": "Closures",
      "searchPlaceholder": "Search a crew",
      "hint": "These days still carry unresolved stops — close them so the bank and the late gutter tell the truth.",
      "looseCount": "{n} unresolved",
      "empty": "Every day is closed out.",
      "alreadyClosed": "Nothing left to close for this day."
    },
    "emptyDay": {
      "button": "Empty the day",
      "confirm": "Empty the day — {count} jobs back to the bank",
      "toast": "{count} jobs returned to the bank"
    },
    "closeDay": {
      "title": "Close out the day",
      "hint": "One outcome per unresolved stop — nothing closes in bulk.",
      "outcome": {
        "completed": "Completed",
        "deferred": "Deferred",
        "cancelled": "Cancelled"
      },
      "openJob": "Open job",
      "unanswered": "{n} stop unanswered | {n} stops unanswered",
      "submit": "Close out the day",
      "submitWithProposed": "Close out the day ({n} proposed) | Close out the day ({n} proposed)",
      "proposedTitle": {
        "completed": "Proposed: started, and the crew moved on after this stop",
        "deferred": "Proposed: never started, and the crew moved on after this stop"
      },
      "toastClosed": "Day closed",
      "toastDeferred": "{n} returned to the bank | {n} returned to the bank"
    },
    "willAssign": "Will assign: {name}",
    "minutesDrive": "{n} min drive",
    "minutesDriveShort": "{n} min",
    "stopNoTime": "No set time",
    "noTargetBar": "No target",
    "unassignedTitle": "Could not be placed this week",
    "excludedTitle": "Left out of the solve",
    "unplaced": {
      "excludedTag": "Excluded",
      "dismiss": "Dismiss this list"
    },
    "reason": {
      "not_geocoded": "Address has no coordinates (geocoding failed or pending)",
      "no_slot_in_window": "No room within its re-treatment window",
      "flexible": "No window — can be placed any time",
      "unassigned": "Could not be placed"
    },
    "confirmSuccess": "Plan confirmed — visit schedules written.",
    "discardSuccess": "Draft plan discarded.",
    "replanSuccess": "Rest of the day replanned — review and confirm.",
    "atRisk": "At risk",
    "riskReason": {
      "visit_cancelled": "A stop was cancelled",
      "visit_skipped": "A stop was skipped",
      "window_drift": "A stop fell outside its re-treatment window",
      "appointment_added": "An appointment was added"
    },
    "runningLong": "Running long",
    "frozen": "Frozen",
    "confirmDialog": {
      "title": "Confirm this plan",
      "description": "Confirming writes these appointment times onto the visits. Call any affected customers first.",
      "bucketDescription": "Confirming commits these jobs to this day — a day-level promise, no appointment times.",
      "dayLevelTime": "{date} (day)",
      "callNote": "Customers to call — their time changed",
      "droppedNote": "No longer on today's route — reschedule or cancel",
      "noCallNeeded": "No call needed — no time promise was made",
      "noChanges": "No customer appointment times change. Safe to confirm.",
      "customer": "Customer",
      "phone": "Phone",
      "newTime": "New time",
      "newAppointment": "new"
    },
    "dayFace": {
      "done": "done",
      "emptyDay": "Empty day",
      "previousDay": "Previous day",
      "nextDay": "Next day",
      "results": "Results",
      "searchPlaceholder": "Customer, address, job #",
      "notEquipped": "Not equipped",
      "addToDay": "Add to this day",
      "adding": "adding | adding {count}",
      "adoptAndAdd": "Adopt the {count} checked + {name} | Adopt the {count} checked + {name}",
      "addAlone": "{name} only",
      "addAloneHint": "The proposition goes back to the bank.",
      "headroom": "{amount} left",
      "overTarget": "over target",
      "removeFromDay": "Remove from this day",
      "notLocated": "Address not located — this stop cannot be shown on the map",
      "nextProposition": "Open",
      "conveyorLabel": "Next proposed day → {day} · {crew}"
    },
    "kind": {
      "bucket": "Flexible day"
    },
    "bucket": {
      "createSuccess": "Day prepared — drag jobs in from the bank.",
      "adopted": "Proposition adopted · {count} stop | Proposition adopted · {count} stops",
      "suggestOrder": "Reorder",
      "suggestOrderHint": "Compute a driving order for this day — times shown are hints, never promises.",
      "suggestSuccess": "Order suggested — the times are driving hints only.",
      "empty": "Drag jobs here from the bank",
      "remove": "Remove from this day",
      "discard": "Delete draft"
    },
    "unplacedChip": "To place on the route",
    "missed": {
      "title": "No crew",
      "count": "{n} to settle | {n} to settle",
      "crewPrompt": "Which crew did it?",
      "crewMissing": "{n} crew to name | {n} crews to name",
      "callBack": "Call {name} back",
      "submit": "Settle",
      "toastResolved": "Settled"
    },
    "bank": {
      "empty": "No unplanned visits."
    },
    "fill": {
      "button": "Fill",
      "hint": "Fill from the bank (respecting its current sector filter), most urgent first, up to the day target",
      "scope": "Fill scope: {sectors}",
      "needsTarget": "Set a day target on this cell first — the target drives the fill.",
      "nothingToFill": "Nothing in the bank fits the remaining budget."
    },
    "dayTarget": {
      "label": "Day target",
      "labelWithUnit": "Day target ({unit})",
      "hint": "A loose cap for this crew's day — used to pick jobs into it.",
      "defaultHint": "The crew's standing default — save to set this day explicitly.",
      "set": "Set target",
      "clear": "Clear",
      "placeholder": "Amount",
      "placeholderStops": "Stops",
      "unitLabel": "Unit",
      "unit": {
        "money": "$",
        "stops": "Stops"
      },
      "actualHint": "Booked work on this plan (prorated per visit)"
    },
    "placement": {
      "bank": "Bank",
      "firm": "Fixed date",
      "window": "The customer wants a period",
      "date": "Date",
      "timeOptional": "Time — optional",
      "appointment": "Appointment",
      "timePromisedLead": "Time promised to the customer",
      "timePromisedRest": "— the route is organized around it."
    },
    "view": {
      "week": "Week",
      "pipeline": "Pipeline",
      "month": "Month"
    },
    "composer": {
      "ghost": {
        "more": "{count} more",
        "proposedLine": "{count} stop proposed | {count} stops proposed"
      },
      "adopt": "Adopt",
      "adoptCount": "Adopt {count} stop | Adopt {count} stops",
      "panel": {
        "composed": "proposed day",
        "close": "Close",
        "checked": "{checked} of {total} checked",
        "toggleAll": "Check all, or none"
      },
      "composing": "composing…",
      "toc": {
        "title": "Proposed days",
        "button": "Composer",
        "pool": "The pool · 14 days",
        "cols": {
          "waiting": "Waiting",
          "placed": "Placed",
          "unplaced": "No day"
        },
        "ripeCount": "{count} ready | {count} ready",
        "filling": "{count} filling | {count} filling",
        "composing": "composing…"
      },
      "demand": {
        "title": "Composed over 14 days"
      },
      "placedOn": "Proposed for {date} · {crew}",
      "noRuns": "No proposed day"
    },
    "candidates": {
      "updatedAgo": "updated {min} min ago",
      "recompose": "Recompose",
      "computing": "Composing the day-runs…",
      "emptyHint": "Runs appear as pending work builds up in each crew's area.",
      "ofCap": "/ {cap}",
      "mapPreview": "Preview the route on a map",
      "reforming": "recomputing…",
      "recomputed": "Recomputed",
      "composeFailedHint": "composition failed — retrying",
      "committed": "Day adopted for {date}",
      "committedPartial": "Adopted for {date} · {dropped} stop already taken | Adopted for {date} · {dropped} stops already taken",
      "stop": {
        "visitOfCount": "visit {ordinal} of {count}",
        "eta": "≈ {time}",
        "openJob": "Open the job"
      },
      "card": {
        "evaluation": "Quotes",
        "untyped": "No type"
      },
      "untyped": {
        "residue": "{count} job with no type | {count} jobs with no type",
        "assignType": "Pick a type",
        "assigned": "Type assigned"
      },
      "run": {
        "ripe": "Ready",
        "filling": "Filling"
      },
      "warnings": {
        "no_capable_crew": "no crew does this type",
        "untyped": "no type — place it by hand"
      }
    },
    "liveMap": {
      "noCustomer": "No customer",
      "stacked": "{count} jobs at this address",
      "unavailable": "The map is unavailable — no Mapbox token is configured.",
      "popover": {
        "openJob": "Open the job",
        "treatmentOfN": "Treatment {index} of {total}",
        "perVisit": "per visit",
        "stopOn": "Stop on {date}",
        "eta": "ETA {time}",
        "draft": "draft plan",
        "promisedOn": "Promised for {date}",
        "completedOn": "Done on {date}",
        "scheduledAt": "Scheduled {date}",
        "overdueSince": "Late since {date}",
        "dueBy": "Due by {date}",
        "window": "Window {from} → {to}"
      }
    },
    "pastEmpty": {
      "label": "No work"
    },
    "offSchedule": {
      "label": "Off schedule",
      "hint": "This crew doesn't normally work this day. You can still fill it — the day takes the crew's usual hours, editable per day."
    },
    "season": {
      "ceilingSentence": "{name}: composer until {date}"
    },
    "propose": {
      "action": "Fill",
      "success": "{count} stop added · {amount} | {count} stops added · {amount}",
      "successStops": "{count} evaluation added | {count} evaluations added",
      "allTypes": "All types",
      "nothingAdded": "The day's appointments already cover the target — nothing added from the bank.",
      "nothing": "Nothing to add: no waiting work matches this truck and day."
    },
    "suggestDay": {
      "action": "Suggest a day",
      "title": "Where does this visit fit?",
      "empty": "No day fits: no open day with room before the window closes.",
      "reasonSector": "{count} stop already in this sector | {count} stops already in this sector",
      "reasonRoom": "{amount} left on the target",
      "reasonWindow": "Inside the window",
      "reasonLate": "Window already closed",
      "place": "Place here"
    },
    "dayOff": {
      "declare": "Cancel the day",
      "reason": "Reason",
      "reasons": {
        "weather": "Weather",
        "crew_unavailable": "Crew unavailable",
        "vehicle_down": "Truck out of service",
        "other": "Other"
      },
      "cancelled": "Day cancelled",
      "reopen": "Reopen the day",
      "reopened": "Day reopened",
      "declareEllipsis": "Cancel the day",
      "declareHint": "{crew} · {date} · {count} stop | {crew} · {date} · {count} stops",
      "reasonRequired": "Pick a reason.",
      "note": "Detail (optional)",
      "noteRequired": "Detail (required for “Other”)",
      "notePlaceholder": "e.g. the replacement arrives Thursday",
      "noteRequiredForOther": "Say in a word what is going on.",
      "noteTooLong": "{max} characters at most.",
      "submitDeclare": "Declare",
      "resolve": "Settle the stops",
      "reviewTitle": "{crew} — day cancelled",
      "reviewHint": "Every stop needs an answer. Customers who were promised a time come first.",
      "stopsToResolve": "{count} stop to resolve | {count} stops to resolve",
      "deferAll": "Defer all",
      "nothingToResolve": "Nothing to resolve on this day.",
      "called": "called",
      "promisedAt": "{time} promised",
      "datedOnly": "Day",
      "dayOnly": "No time",
      "submit": "Close the day"
    },
    "previousWeek": "Previous week",
    "nextWeek": "Next week",
    "popover": {
      "crew": {
        "intent": "Planned for {crew}",
        "placement": "{crew}’s day"
      }
    },
    "noCrews": "No crews yet",
    "noCrewsHint": "The board plans crews’ days: create one under « Fleet ».",
    "previousMonth": "Previous month",
    "nextMonth": "Next month",
    "month": {
      "off": "off",
      "unassigned": "No crew",
      "unavailable": "The month could not be loaded.",
      "marks": {
        "done": "Done",
        "underway": "Under way",
        "planned": "Planned",
        "unresolved": "No verdict",
        "skipped": "Skipped",
        "deferred": "Back to the bank"
      },
      "evaluations": "look-sees",
      "day": {
        "unavailable": "This day could not be loaded.",
        "empty": "Nothing that day.",
        "openWeek": "Open in Week",
        "buildDay": "Build this day",
        "doneAt": "Done at {time}"
      },
      "rowState": {
        "done": "Done",
        "skipped": "Skipped",
        "deferred": "Back to the bank",
        "unresolved": "No verdict",
        "underway": "Under way",
        "planned": "Planned"
      }
    },
    "crewsUnavailable": "The crews could not be loaded, so the board has no rows to draw.",
    "pickWeek": "Pick a week"
  },
  "proposals": {
    "title": "Proposals",
    "index": {
      "empty": "No proposals yet.",
      "tabs": {
        "all": "All"
      },
      "sort": {
        "placeholder": "Sort",
        "createdNewest": "Newest first",
        "createdOldest": "Oldest first",
        "status": "Status"
      },
      "columns": {
        "status": "State",
        "customer": "Customer",
        "dossier": "Job",
        "amount": "Amount",
        "due": "Due"
      },
      "due": {
        "expires": "expires {date}",
        "on": "on {date}",
        "signed": "signed {date}",
        "since": "{count} d old"
      }
    },
    "builder": "Proposal Builder",
    "clientReview": "Client Review",
    "acceptAndSign": "Accept & Sign",
    "acceptAndSignSubtitle": "I authorize the work described in « {title} ».",
    "beginWork": "Accept & sign",
    "startQuote": "Write quote",
    "quoteDrawerTitle": "Quote",
    "signedTitle": "Signed",
    "signedSubtitle": "{title} · {amount}",
    "acceptance": "Proposal & Acceptance",
    "customerSignature": "Customer Signature",
    "waitingSignature": "Waiting for customer signature...",
    "noneYet": "No quote yet",
    "notFound": "Quote not found",
    "noProposal": "No proposal has been built for this job yet.",
    "afterEvaluation": "The quote gets written after the evaluation.",
    "noItems": "No items added yet.",
    "acceptedBanner": "This proposal was accepted by the customer.",
    "number": "Proposal #{number}",
    "itemCount": "{count} item | {count} items",
    "create": "Create Proposal",
    "createSuccess": "Proposal created successfully.",
    "acceptSuccess": "Proposal accepted! You can now begin work.",
    "subtotal": "Subtotal",
    "discount": "Discount",
    "taxes": "Taxes",
    "total": "Total",
    "addTax": "Add Tax",
    "removeTax": "Remove",
    "overrideRate": "Override",
    "fromCatalog": "From catalog",
    "customTax": "Custom rate",
    "validUntil": "Valid until {date}",
    "expired": "Expired",
    "setExpiry": "Expiry date",
    "clearExpiry": "Remove the date",
    "margin": "Margin",
    "marginTooltip": "Margin — profit % over cost",
    "details": {
      "title": "Details",
      "addPlaceholder": "Add a detail",
      "addChip": "+ Another detail"
    },
    "row": {
      "addDetail": "+ detail",
      "suggested": "Suggested details",
      "taxes": "Taxes",
      "discountLine": "Line discount",
      "addDescription": "+ description",
      "moveTo": "Move to",
      "toAddons": "Add-ons",
      "includeBack": "Include in the quote",
      "remove": "Remove line"
    },
    "columns": {
      "line": "Line",
      "quantity": "Quantity",
      "price": "Price"
    },
    "addLineFoot": "Add a line",
    "pendingLinePlaceholder": "Line name, or search the catalog",
    "lineItemKind": {
      "material": "Material",
      "labor": "Labor",
      "fee": "Fee"
    },
    "unit": "Unit",
    "unitPlaceholder": "ea, hr, ft...",
    "discountPercent": "Discount %",
    "addOn": "Add-on",
    "markAsAddOn": "Mark as add-on (excluded from total)",
    "taxable": "Taxable",
    "taxableShort": "Tax",
    "addOns": "Add-ons",
    "includeItem": "Include",
    "excludeItem": "Exclude",
    "newSection": "New section",
    "newSectionDefault": "New section",
    "renameGroup": "Rename section",
    "explodeGroup": "Ungroup (keep items)",
    "deleteSectionAndItems": "Delete section & items",
    "deleteSectionConfirm": "Delete \"{name}\" and all of its line items? This cannot be undone.",
    "replacedUnderYou": "This quote was replaced",
    "states": {
      "draft": "Draft",
      "pending": "Pending",
      "accepted": "Accepted",
      "rejected": "Rejected",
      "lost": "Lost",
      "expired": "Expired",
      "superseded": "Superseded"
    },
    "timeline": {
      "sentBy": "Quote sent by {channel}",
      "delivered": "Delivery recorded",
      "title": "History",
      "created": "Proposal {number} created",
      "presented": "Presented to customer",
      "accepted": "Accepted",
      "acceptedSigned": "Accepted with signature",
      "acceptedManually": "Approved manually",
      "acceptedVerbally": "Accepted — verbal agreement",
      "rejected": "Declined",
      "revised": "Reopened for revision",
      "expired": "Marked expired",
      "assemblyApplied": "Added assembly \"{name}\"",
      "groupRemoved": "Removed section \"{name}\"",
      "groupExploded": "Dissolved section \"{name}\"",
      "discountUpdated": "Updated the discount",
      "validitySet": "Set expiry to {date}",
      "validityChanged": "Changed expiry from {from} to {to}",
      "validityCleared": "Removed expiry date",
      "taxAdded": "Added tax \"{name}\"",
      "taxRemoved": "Removed tax \"{name}\"",
      "taxRateOverridden": "Overrode rate for \"{name}\"",
      "superseded": "Superseded by {number} — the customer chose another",
      "supersededNoPaper": "Superseded — sold without a quote",
      "coverageAdded": "Section {label} added · {number}",
      "coverageAddedMany": "Sections added: {list}"
    },
    "forfait": {
      "badge": "Bundle",
      "createsJob": "+ creates the {types} job",
      "partOf": "Part of:",
      "typeChip": "Type: {name}",
      "backToOwnType": "Back to the template's type",
      "addTypedSection": "+ Section of another type",
      "pickType": "Section type",
      "seedFrom": "Start from the template",
      "seedNone": "Empty section",
      "add": "Add the section"
    },
    "quote": {
      "howMuch": "How much?",
      "standardFor": "Quote for {type}",
      "standardNone": "No standard quote for {type}",
      "standardNoType": "No job type",
      "agreedHint": "Agree on a price",
      "change": "Change",
      "unpriced": "No price",
      "pricePlaceholder": "Price",
      "discarded": "Draft discarded",
      "lockedHint": "Already presented to the customer — quantities are locked"
    },
    "presentToCustomer": "Make available to the customer",
    "presentOnTablet": "Present to the customer",
    "publicLink": {
      "menu": "Public link",
      "copy": "Copy the link",
      "copied": "Link copied",
      "sendEmail": "Send by email",
      "emailSent": "Email sent to the customer",
      "regenerate": "Regenerate the link",
      "regenerated": "New link created — every shared link is now dead"
    },
    "viewPdf": "View PDF",
    "revise": "Revise",
    "recordDecision": "Record decision",
    "markApproved": "Mark approved",
    "markApprovedConfirm": "Record that the customer approved this on a printed copy? This will be logged under your name.",
    "markDeclined": "Mark declined",
    "markDeclinedConfirm": "Record that the customer declined this proposal? This will be logged under your name.",
    "approvedManually": "Approved manually",
    "awaitingDecision": "Awaiting customer decision",
    "optionalTotal": "Optional add-ons",
    "inProposalCount": "{count} already in this quote",
    "expiredOn": "Expired {date}",
    "removeFromSection": "Remove from section",
    "emptySection": "Empty section — move items here or add parts.",
    "sectionActions": "Manage this section.",
    "moveGroupUp": "Move up",
    "moveGroupDown": "Move down",
    "reviewTitle": "Your quote",
    "reviewSubtitle": "Please review the work and the amount, then sign below.",
    "acceptedDocument": "Accepted quote"
  },
  "parts": {
    "suggest": {
      "loading": "Searching the catalog…",
      "custom": "Free line “{name}”",
      "onHand": "{n} in stock"
    },
    "title": "Price Book",
    "addItem": "Add Item",
    "addTitle": "Add to Price Book",
    "emptyTitle": "Empty Price Book",
    "createSuccess": "Item added to price book.",
    "updateSuccess": "Item updated.",
    "deleteSuccess": "Item removed.",
    "deleteConfirmTitle": "Remove from price book?",
    "deleteConfirmDescription": "Remove {name} from the price book? Existing line items won't be affected.",
    "searchPlaceholder": "Search price book",
    "fields": {
      "name": "Item Name",
      "namePlaceholder": "e.g. Standard Labor Rate",
      "description": "Description",
      "descriptionPlaceholder": "Optional details",
      "unitPrice": "Unit Price ($)",
      "sku": "SKU / Code",
      "skuPlaceholder": "e.g. EL-001",
      "unit": "Unit",
      "unitPlaceholder": "ea, hr, m²...",
      "costPrice": "Cost price ($)",
      "taxable": "Taxable",
      "onHand": "On Hand",
      "trackInventory": "Track inventory",
      "lowStockThreshold": "Low-stock threshold"
    },
    "pickerPlaceholder": "Pick an item",
    "tabs": {
      "all": "All",
      "lowStock": "Low stock"
    },
    "sort": {
      "nameAsc": "Name (A–Z)",
      "nameDesc": "Name (Z–A)",
      "priceHighest": "Price (highest)",
      "priceLowest": "Price (lowest)",
      "newest": "Newest first",
      "oldest": "Oldest first"
    },
    "stock": {
      "title": "Stock",
      "notTracked": "Inventory is not tracked for this item. Enable tracking in the item settings to manage stock.",
      "lowStock": "Low stock",
      "adjustAction": "Adjust stock",
      "adjustTitle": "Adjust stock",
      "adjustDescription": "Add or remove quantity, or set the counted total.",
      "adjustSuccess": "Stock updated.",
      "adjustHint": "Use a negative amount to remove stock.",
      "modes": {
        "adjust": "Adjust ±",
        "set": "Set count"
      },
      "fields": {
        "amount": "Amount",
        "newCount": "New count",
        "note": "Note",
        "notePlaceholder": "e.g. Received delivery, damaged unit..."
      }
    },
    "movements": {
      "title": "Movement History",
      "empty": "No stock movements yet.",
      "loadMore": "Load more",
      "system": "System",
      "reasons": {
        "adjustment": "Adjustment",
        "count": "Count"
      },
      "fields": {
        "date": "Date",
        "reason": "Reason",
        "delta": "Change",
        "performedBy": "By",
        "note": "Note"
      }
    }
  },
  "settings": {
    "title": "Settings",
    "subtitle": "Manage your profile and organization configuration.",
    "updateSuccess": "Profile updated successfully.",
    "backToApp": "Back to app",
    "groups": {
      "company": "The company",
      "field": "The field",
      "accounting": "Accounting"
    },
    "identity": {
      "dataSources": {
        "osm": "© OpenStreetMap contributors,",
        "osmLicence": "ODbL",
        "quebec": "Data: © Gouvernement du Québec — Référentiel québécois des adresses and Découpage administratif, adapted,",
        "quebecLicence": "CC BY 4.0"
      },
      "languageHint": "Your documents and emails to customers.",
      "logo": {
        "empty": "No logo",
        "instructions": "Click or drag an image.",
        "remove": "Remove"
      }
    },
    "paper": {
      "contactEmail": "Customer contact email",
      "contactEmailHint": "Printed on your documents, and the reply address of what you send.",
      "contactEmailMissing": "Without an email, your customers cannot reply to what you send."
    },
    "territory": {
      "anchor": {
        "title": "Where trips start"
      }
    },
    "tabs": {
      "profile": "Profile",
      "general": "Identity",
      "paper": "Business paper",
      "members": "Members",
      "businessHours": "Business hours",
      "taxes": "Taxes",
      "payments": "Payments",
      "sectors": "Territory",
      "imports": "Imports",
      "notifications": "Notifications",
      "weather": "Weather",
      "closures": "Closures"
    },
    "payments": {
      "title": "Payments",
      "hint": "How your customers pay their invoices. The money goes straight to your company, never through Vitesse.",
      "interac": {
        "title": "Interac e-Transfer",
        "description": "Printed on every invoice still to pay: the address, the amount and the invoice number to type in the message. Free for you.",
        "email": "Autodeposit address",
        "placeholder": "payments{'@'}company.ca",
        "invalid": "Enter a complete email address (e.g. payments{'@'}company.ca)."
      },
      "cardTitle": "Stripe account",
      "contactEmail": "Stripe account email",
      "contactEmailHint": "The address Stripe uses to reach the account holder. Your customers never see it.",
      "states": {
        "disconnected": "Not connected",
        "pending": "Setup to finish",
        "active": "Active"
      },
      "descriptions": {
        "disconnected": "Connect a Stripe account to let customers pay invoices by card from their invoice page.",
        "pending": "The Stripe account exists but onboarding is not finished — payments stay off until Stripe enables charges.",
        "active": "Card payments are enabled. Refunds, disputes and payouts live in your own Stripe dashboard."
      },
      "connect": "Connect Stripe",
      "resume": "Finish the setup",
      "verify": "Verify",
      "openDashboard": "Open the Stripe dashboard",
      "restart": "Start over",
      "restartConfirmTitle": "Start the Stripe connection over?",
      "restartConfirmBody": "The unfinished setup is abandoned. \"Connect Stripe\" will start from scratch."
    },
    "profile": {
      "title": "Profile Information",
      "subtitle": "Update your personal details.",
      "firstName": "First Name",
      "lastName": "Last Name",
      "locale": "Language",
      "save": "Save Changes"
    },
    "contactSupport": "Contact Support",
    "organization": {
      "proposalValidity": "Proposal validity (days)",
      "proposalValidityHint": "A proposal expires this many days after its draft is created. Leave blank for no expiry.",
      "hqPlaceholder": "e.g. 5195 Boulevard Guillaume-Couture, Lévis, QC",
      "hqHint": "Used to estimate drive times for the service-area badge. Coordinates resolve automatically.",
      "hqPending": "Resolving the address…",
      "viewHqMap": "View the HQ on a map",
      "hqResolved": "Resolved: {lat}, {lng}",
      "serviceAreaHint": "Beyond this drive time from the head office, the location wears the Out of area badge. Never blocking.",
      "letterhead": "Letterhead",
      "letterheadHint": "What the public quote page shows your customer. Empty fields simply don't appear.",
      "taglinePlaceholder": "e.g. Electrical contractor",
      "rbqPlaceholder": "e.g. 5678-1234-01",
      "locale": "Default Language",
      "businessHours": {
        "title": "Business hours",
        "hint": "Default working days and hours. Route planning only schedules visits on open days, within these hours.",
        "open": "Open",
        "closed": "Closed",
        "start": "Opening time",
        "end": "Closing time",
        "endAfterStart": "Closing time must be after opening time.",
        "days": {
          "mon": "Monday",
          "tue": "Tuesday",
          "wed": "Wednesday",
          "thu": "Thursday",
          "fri": "Friday",
          "sat": "Saturday",
          "sun": "Sunday"
        }
      }
    },
    "taxes": {
      "title": "Tax Rates",
      "subtitle": "Define the taxes applied to proposals.",
      "nav": "Taxes"
    }
  },
  "taxes": {
    "title": "Tax Rates",
    "subtitle": "Configure taxes to apply on proposals.",
    "addNew": "New Tax",
    "createSuccess": "Tax created.",
    "updateSuccess": "Tax updated.",
    "deactivateSuccess": "Tax deactivated.",
    "restoreSuccess": "Tax restored.",
    "deactivate": "Deactivate",
    "restore": "Restore tax",
    "addedToProposal": "Tax added.",
    "removedFromProposal": "Tax removed.",
    "deleteConfirmTitle": "Deactivate Tax?",
    "deleteConfirmDescription": "Deactivating \"{name}\" will hide it from new proposals. Existing proposal taxes are not affected.",
    "noTaxes": "No taxes configured yet.",
    "fields": {
      "name": "Tax Name",
      "namePlaceholder": "e.g. GST, QST, HST",
      "rate": "Rate (%)",
      "ratePlaceholder": "e.g. 14.975",
      "registrationNumber": "Registration number",
      "registrationNumberPlaceholder": "e.g. 123456789 RT0001",
      "active": "Active",
      "includeByDefault": "Add to new proposals by default"
    }
  },
  "nav": {
    "operations": "Operations",
    "sales": "Sales",
    "salesDesk": "Pipeline",
    "clients": "Clients",
    "resources": "Resources"
  },
  "catalog": {
    "title": "Catalog"
  },
  "pipeline": {
    "card": {
      "wonVerbal": "Work accepted — plan it",
      "wonVerbalConfirmTitle": "Work accepted verbally?",
      "wonVerbalToast": "Deal won — the work is created."
    },
    "win": {
      "submit": "Confirm and plan",
      "cancelsEvaluation": "The evaluation in the bank will be cancelled."
    }
  },
  "salesFlow": {
    "filters": {
      "title": "Filters"
    },
    "renew": {
      "title": "{label} — what did they say?",
      "titlePlain": "Renew — what did they say?",
      "underpricedHint": "Price judged too low last year",
      "plan": {
        "shared": "Renews bundle {number}: {jobs}",
        "stays": "{label} stays ({reason})",
        "alternative": "+ the unpicked option {number} comes back beside it",
        "alternativeExtras": "+ the unpicked option {number} (+ {extras}) comes back beside it",
        "otherAmount": "Another amount → New price",
        "card": "Bundle · {number}"
      },
      "card": {
        "send": "Same price",
        "prepare": "New price",
        "won": "Sold on the phone",
        "reassess": "Re-assess"
      },
      "hint": {
        "send": "Resends last year's quote, at {amount}.",
        "prepare": "Opens last year's quote to redo the price.",
        "won": "The job is born sold; its first visit goes to the bank.",
        "reassess": "An evaluation goes to the bank; the old price stays at hand."
      },
      "landsLabel": "The job goes to",
      "lands": {
        "send": "Sales · Quote not signed",
        "prepare": "Sales · Quote to write",
        "won": "Bank",
        "reassess": "Bank"
      },
      "amount": "How much?",
      "amountHint": "last year",
      "submit": {
        "send": "Send the quote",
        "prepare": "Write the quote",
        "won": "Create sold",
        "reassess": "Plan the evaluation"
      },
      "toast": {
        "sent": "Quote sent for {label}",
        "sentNoEmail": "Renewed for {label} — link issued, no email on file",
        "notPresented": "Renewed for {label} — the quote did not go out: {reason}",
        "prepared": "Renewed for {label}",
        "won": "Sold for {label}",
        "reassess": "Evaluation in the bank for {label}"
      }
    },
    "relance": {
      "title": "Chase — today",
      "placeholder": "What the customer said (optional)",
      "returnOn": "Look again on",
      "withNote": "{line} — “{note}”"
    },
    "snooze": {
      "control": "Postpone",
      "controlSet": "Postponed to {date}",
      "title": "Postpone this file",
      "tomorrow": "Tomorrow",
      "inThreeDays": "In 3 days",
      "nextMonday": "Next Monday",
      "pickDate": "A date",
      "reason": "Reason (optional)",
      "submit": "Postpone",
      "lift": "Cancel the postponement",
      "until": "Postponed to {date}",
      "include": "Include postponed",
      "toastSet": "Postponed to {date}.",
      "toastLifted": "Postponement cancelled.",
      "undo": "Undo",
      "historySet": "Postponed to {date}",
      "historySetWhy": "Postponed to {date} — {reason}",
      "historyCleared": "Postponement cancelled"
    },
    "page": {
      "sales": "Sales",
      "renewals": "Renewals",
      "payments": "Collections"
    },
    "campaign": {
      "season": "Season",
      "since": "Customers since",
      "progress": {
        "toCall": "{n} to call",
        "called": "{n} called",
        "renewed": "{n} renewed",
        "unreached": "{n} not reached",
        "declined": "{n} declined",
        "cohort": "of {n} customers"
      },
      "end": "End the campaign",
      "endConfirmTitle": "End the {label} campaign?",
      "endConfirmLine": "Every customer has been called back. The list empties and the badge goes away. | {n} customer was not called back: they will be marked « not reached » (not a refusal) and come back in the next campaign. The list empties and the badge goes away. | {n} customers were not called back: they will be marked « not reached » (not a refusal) and come back in the next campaign. The list empties and the badge goes away.",
      "ended": "Campaign ended",
      "noSeason": "No open season — the campaign starts when the year opens.",
      "lastYearControl": "Last job in",
      "all": "All",
      "empty": "Nobody to call.",
      "emptyEnded": "Campaign ended — nobody left to call.",
      "emptyYear": "Nobody to call whose last job was in {year}.",
      "line": {
        "callBack": "Call back on {date}"
      },
      "row": {
        "jobs": "{n} jobs",
        "addresses": "{n} address | {n} addresses"
      },
      "card": {
        "to_answer": "To answer",
        "renewed": "Renewed",
        "refused": "Declined for {year}",
        "declined_year": "Not in {year}",
        "declined_forever": "Never again",
        "unreached": "Not reached for {year}",
        "finishedPartial": "{done} of {total} visits · last on {date}"
      },
      "declineAll": "Decline all for {year}",
      "declineAllTitle": "Decline all for {year}?",
      "declineAllLine": "{n} job becomes « Not in {year} ». It comes back next campaign. | {n} jobs become « Not in {year} ». They come back next campaign.",
      "snoozeAll": "Snooze all",
      "snoozeAllTitle": "Snooze every job still to answer",
      "beyondReach": "Only the first 100 are shown — narrow with the search or « Last job in ».",
      "sinceDefault": "Default (3 years)",
      "launcher": "Pick a customer in the list, or start with the first: each call settles their whole file.",
      "start": "Start calling",
      "underpriced": "Price judged too low"
    },
    "reason": {
      "all": "All",
      "to_write": "Quote to write",
      "to_assess": "Evaluation to plan",
      "sent": "Quote not signed",
      "prepay": "Payment before work",
      "unpaid": "Unpaid invoice"
    },
    "reasonLine": {
      "renewalPrefix": "Renewal · ",
      "toWrite": "Quote to write · evaluated {n} d ago",
      "written": "Quote written, not sent · {n} d",
      "toAssess": "Evaluation to plan · received {n} d ago",
      "toWriteNew": "Quote to write · received {n} d ago",
      "sent": "Quote not signed · sent {n} d ago",
      "unpaid": "Invoice sent {n} d ago",
      "prepayToBill": "To invoice before the work · signed {n} d ago",
      "prepayAwaiting": "Payment due before the work · invoiced {n} d ago"
    },
    "emptyReason": {
      "to_write": "Nobody is waiting for a quote.",
      "to_assess": "No request waiting.",
      "sent": "No unsigned quote.",
      "unpaid": "No unpaid invoice.",
      "prepay": "No work is waiting for a payment."
    },
    "emptyAll": "Nothing to do — all caught up.",
    "state": {
      "to_evaluate": "To evaluate",
      "to_write": "To write",
      "written": "Written, not sent",
      "unpriced": "Written, {n} line unpriced | Written, {n} lines unpriced"
    },
    "beyondReach": "Only the oldest are shown here — narrow with the search or the type filter.",
    "noName": "No name",
    "group": {
      "to_renew": "To renew",
      "to_contact": "To contact",
      "to_produce": "To quote",
      "proposals": "No answer",
      "invoices": "Unpaid"
    },
    "act": {
      "open_builder": "Write the quote",
      "renew": "Renew",
      "decline_year": "Not this year",
      "decline_forever": "Never again",
      "declinedYear": "No renewal for {year}.",
      "declinedForever": "Will not be renewed again.",
      "reconsidered": "Refusal undone.",
      "otherSeasons": "The other years",
      "writeFrom": "Write: {offer}",
      "writeBlank": "Blank document",
      "otherOffers": "The type's other offers",
      "send_proposal": "Send the quote",
      "sent": "Quote sent to the customer.",
      "sentNoEmail": "Quote ready and the link is live — no email on file.",
      "noEmail": "No email on file",
      "unpriced": "Add a price before sending",
      "unpricedLine": "A line has no price yet",
      "relance": "Resend by email",
      "present": "Make available to the customer",
      "presented": "Quote available to the customer.",
      "confirm_sale": "Confirm the sale",
      "mark_transmitted": "Mark as handed over",
      "revise": "Edit",
      "deliveredNoted": "Delivery recorded.",
      "expiredBlock": "Expired — extend the validity first",
      "mark_paid": "Mark as paid",
      "claim": "Email the invoice",
      "claimMany": "Email the {count} invoices",
      "otherChannels": "Other ways to send",
      "sendBySms": "By text message",
      "soon": "soon",
      "extend": "Extend validity",
      "extendUntil": "Until {date}",
      "lost": "Mark as lost",
      "copy_link": "Copy customer link",
      "view_proposal": "View quote",
      "open_invoice": "Open invoice",
      "bill": "Invoice",
      "issue_bill": "Issue the invoice",
      "require_payment_first": "Require payment before work for this customer",
      "billed": "Invoice {number} issued",
      "issuedBill": "Invoice issued",
      "requiredPaymentFirst": "{name} will pay before the work from now on",
      "extended": "Validity extended by {days} days.",
      "plan_evaluation": "Schedule the evaluation",
      "plan_work": "Schedule the work",
      "remind": "Mark as chased",
      "reminded": "Follow-up recorded.",
      "remindedParked": "Follow-up recorded — snoozed until {date}.",
      "mailedParked": "Email sent — snoozed until {date}."
    },
    "due": {
      "createdAgo": "Received today | Received yesterday | Received {n} d ago",
      "renewedAgo": "Renewed today | Renewed yesterday | Renewed {n} d ago",
      "openedAgo": "Season opened today | Season opened yesterday | Season opened {n} d ago",
      "when": "today | yesterday | {n} d ago",
      "doneOn": "done {date}",
      "doneOnCap": "Done {date}",
      "assessedAgo": "Assessed today | Assessed yesterday | Assessed {n} d ago",
      "sentAgo": "Delivered today | Delivered yesterday | Delivered {n} d ago",
      "presentedAgo": "Presented today | Presented yesterday | Presented {n} d ago",
      "invoicedAgo": "Invoiced today | Invoiced yesterday | Invoiced {n} d ago",
      "signedAgo": "Signed today | Signed yesterday | Signed {n} d ago",
      "neverReminded": "Never chased",
      "neverClaimed": "Never claimed",
      "remindedAgo": "Chased today | Chased yesterday | Chased {n} d ago",
      "claimedAgo": "Claimed today | Claimed yesterday | Claimed {n} d ago",
      "expiredShort": "Expired",
      "age": "{n} d"
    },
    "card": {
      "history": "History",
      "renewalOf": "Renewal of",
      "close": "Close",
      "email": "Email",
      "smsSoon": "Texting is on its way.",
      "noReach": "No contact details",
      "noType": "No type",
      "addAccess": "Add an access note",
      "addDescription": "Add a description",
      "descriptionDoor": "Description",
      "viewMap": "View on the map",
      "openDeal": "Open the file",
      "otherDossiers": "Their other files",
      "followUp": "Follow-up",
      "addFollowUp": "Add a follow-up note",
      "shrink": "Minimize"
    },
    "paper": {
      "others": "no other document | 1 other document | {n} other documents",
      "copyLink": "Copy the link",
      "viewPdf": "View the PDF",
      "expand": "Expand",
      "send": "Send",
      "sendThis": "Email {number}",
      "draft": "Draft {number}",
      "notSent": "not sent",
      "unpriced": "{n} line unpriced | {n} lines unpriced",
      "noPrice": "no price",
      "ago": "today | yesterday | {n} days ago",
      "channel": {
        "email": "email",
        "sms": "text",
        "manual": "follow-up",
        "in_person": "in person",
        "phone": "phone",
        "paper": "paper"
      },
      "proposal": "Quote",
      "invoice": "Invoice"
    },
    "door": {
      "dealGone": "This file is no longer open.",
      "workDated": "The work is already scheduled — only the sale is left to confirm.",
      "openBuilderPage": "Open the full page"
    },
    "start": "Start with {name}"
  },
  "records": {
    "jobs": "Jobs",
    "jobsHere": "Jobs at this address",
    "newJob": "New job",
    "addresses": "{n} address | {n} addresses",
    "moreJobs": "See the other one | See the {n} others",
    "note": "Note",
    "addNote": "Add a note",
    "contact": "Client",
    "company": "Company",
    "address": "Address"
  },
  "leads": {
    "actions": {
      "create": "New lead"
    },
    "title": "Leads",
    "searchPlaceholder": "Search for a customer",
    "filterByState": "State",
    "allStates": "All states",
    "ageDays": "{count} d",
    "fields": {
      "state": "State",
      "value": "Value",
      "age": "Age"
    },
    "tabs": {
      "all": "All",
      "active": "Active",
      "lost": "Lost"
    },
    "state": {
      "new": "Not started",
      "toContact": "To contact",
      "toPlace": "Agreed — to place",
      "evaluationBooked": "Evaluation booked",
      "toQuote": "To quote",
      "sent": "Quote sent",
      "stalled": "Stalled",
      "lost": "Lost"
    }
  },
  "filters": {
    "active": "Filters:",
    "remove": "Remove {name}",
    "clearAll": "Clear all",
    "assignees": "Assignees",
    "types": "Types",
    "seasons": "Season",
    "noSeason": "No season",
    "noOpenSeason": "No open season",
    "notRenewed": "Not renewed"
  },
  "admin": {
    "title": "Administration",
    "errors": {
      "title": "Errors"
    },
    "features": {
      "title": "Features",
      "saved": "Feature updated",
      "flippedOn": "Turned on",
      "flippedOff": "Turned off",
      "console": "console",
      "sales_enabled": {
        "label": "Sales",
        "description": "Off hides every quote and estimate surface."
      },
      "weather_enabled": {
        "label": "Weather",
        "description": "Turns on Weather."
      },
      "housecall_migration_enabled": {
        "label": "Housecall Pro migration",
        "description": "Shows \"Housecall Pro migration\" on Imports, to admins."
      }
    },
    "goodJob": {
      "title": "GoodJob"
    },
    "organizations": {
      "title": "Organizations",
      "subtitle": "Every tenant on the platform",
      "new": "New organization",
      "searchPlaceholder": "Search by name",
      "none": "No organizations",
      "filterAll": "All",
      "filterActive": "Active",
      "filterSuspended": "Suspended",
      "statusActive": "Active",
      "statusSuspended": "Suspended",
      "columns": {
        "name": "Organization",
        "created": "Created",
        "members": "Members",
        "jobs30d": "Jobs (30 d)",
        "lastActivity": "Last activity",
        "status": "Status"
      }
    },
    "provision": {
      "title": "New organization",
      "orgSection": "Organization",
      "ownerSection": "Owner",
      "name": "Name",
      "locale": "Language",
      "timeZone": "Time zone",
      "billingEmail": "Billing email",
      "hqAddress": "HQ address",
      "quebecPack": "Québec pack",
      "quebecPackHint": "Seeds GST 5% + QST 9.975% and the default warehouse",
      "ownerEmail": "Email",
      "ownerEmailHint": "A new email gets an invitation; an existing account is granted access without one.",
      "ownerFirstName": "First name",
      "ownerLastName": "Last name",
      "submit": "Create the organization",
      "successInvited": "Organization created — invitation sent to the owner",
      "successAttached": "Organization created — existing account granted access"
    },
    "detail": {
      "loadError": "Failed to load the organization",
      "createdOn": "Created {date}",
      "overview": "Overview",
      "members": "Members ({count})",
      "memberActive": "Active",
      "invitationPending": "Invitation sent {date}",
      "invite": "Invite a member",
      "inviteSubmit": "Grant access",
      "inviteSentSuccess": "Invitation sent",
      "accessGrantedSuccess": "Access granted",
      "role": "Role",
      "resend": "Resend",
      "resendSuccess": "Invitation resent",
      "remove": "Remove",
      "removeSuccess": "Access revoked",
      "removeConfirmTitle": "Revoke access?",
      "removeConfirmBody": "{name} will immediately lose access to this organization.",
      "suspend": "Suspend",
      "suspendSuccess": "Organization suspended",
      "suspendConfirmTitle": "Suspend this organization?",
      "suspendConfirmBody": "{name} will stop serving immediately — its members lose access until it is restored.",
      "restore": "Restore",
      "restoreSuccess": "Organization restored"
    },
    "roles": {
      "member": "Member",
      "admin": "Admin",
      "owner": "Owner"
    },
    "notFound": {
      "title": "Page not found",
      "body": "There is nothing here."
    }
  },
  "common": {
    "pdf": {
      "unavailable": "The PDF is not available right now.",
      "retry": "Try again",
      "download": "Download the PDF"
    },
    "loadMore": "Load more",
    "home": "Home",
    "contacts": "Contacts",
    "jobs": "Jobs",
    "parts": "Price Book",
    "settings": "Settings",
    "theme": {
      "dark": "Dark theme",
      "light": "Light theme"
    },
    "light": "Light",
    "dark": "Dark",
    "cropImage": "Crop Image",
    "cropImageDescription": "Adjust your image to fit perfectly.",
    "back": "Back",
    "cancel": "Cancel",
    "apply": "Apply",
    "dragToReorder": "Drag to reorder",
    "confirm": "Confirm",
    "moreActions": "More actions",
    "create": "Create",
    "update": "Update",
    "edit": "Edit",
    "view": "View",
    "delete": "Delete",
    "moveUp": "Move up",
    "moveDown": "Move down",
    "save": "Save",
    "add": "Add",
    "done": "Done",
    "close": "Close",
    "map": "Map",
    "sitePhotos": "Site Photos",
    "addPhoto": "Add Photo",
    "photoUploaded": "Photo uploaded successfully.",
    "photoDeleted": "Photo deleted.",
    "noPhotosCaptured": "No photos captured yet",
    "noPhotosHint": "Photos the crew takes on site show up here.",
    "uploadFailed": "The upload failed. Try again.",
    "deletePhotoTitle": "Delete this photo?",
    "deletePhotoDescription": "The photo will be removed from the job's record. This cannot be undone.",
    "hello": "Hello",
    "technician": "Technician",
    "clients": "Clients",
    "clientDirectory": "Directory of customers.",
    "clientDetails": "Client Details",
    "call": "Call",
    "loadFailed": "Could not load",
    "filters": "Filters",
    "text": "Text",
    "reach": "Call or text",
    "clearSearch": "Clear search",
    "email": "Email",
    "actions": "Actions",
    "timeline": "Timeline",
    "new": "New",
    "present": "Present",
    "exit": "Exit",
    "comingSoon": "Price book integration coming soon.",
    "searchPlaceholder": "Search",
    "noItems": "No items found",
    "noMatches": "No results",
    "clearFilters": "Clear filters",
    "endOfList": "End of list",
    "noResults": "No results",
    "loading": "Loading...",
    "more": "More",
    "website": "Website",
    "required": "This field is required",
    "showing": "Showing {from}–{to} of {total}",
    "previous": "Previous",
    "next": "Next",
    "pageOf": "Page {page} of {pages}",
    "selectOption": "Select an option",
    "selectDate": "Select a date",
    "selectDateTime": "Select date & time",
    "from": "From",
    "to": "To",
    "user": "User",
    "unknownUser": "Unknown User",
    "quantity": "Quantity",
    "total": "Total",
    "summary": "Summary",
    "tryAgain": "Try Again",
    "somethingWentWrong": "Something went wrong",
    "toHandle": "To handle",
    "appearance": "Appearance",
    "darkMode": "Dark mode",
    "switchOrg": "Switch organization",
    "logoutConfirmTitle": "Log out?",
    "logoutConfirmBody": "You will need to sign in again to see your day.",
    "active": "Active",
    "inactive": "Inactive",
    "all": "All",
    "none": "None",
    "import": "Import",
    "companies": "Companies",
    "name": "Name",
    "countries": {
      "CA": "Canada",
      "US": "United States"
    },
    "provinces": {
      "AB": "Alberta",
      "BC": "British Columbia",
      "MB": "Manitoba",
      "NB": "New Brunswick",
      "NL": "Newfoundland and Labrador",
      "NS": "Nova Scotia",
      "NT": "Northwest Territories",
      "NU": "Nunavut",
      "ON": "Ontario",
      "PE": "Prince Edward Island",
      "QC": "Quebec",
      "SK": "Saskatchewan",
      "YT": "Yukon"
    },
    "states": {
      "AL": "Alabama",
      "AK": "Alaska",
      "AZ": "Arizona",
      "AR": "Arkansas",
      "CA": "California",
      "CO": "Colorado",
      "CT": "Connecticut",
      "DC": "District of Columbia",
      "DE": "Delaware",
      "FL": "Florida",
      "GA": "Georgia",
      "HI": "Hawaii",
      "ID": "Idaho",
      "IL": "Illinois",
      "IN": "Indiana",
      "IA": "Iowa",
      "KS": "Kansas",
      "KY": "Kentucky",
      "LA": "Louisiana",
      "ME": "Maine",
      "MD": "Maryland",
      "MA": "Massachusetts",
      "MI": "Michigan",
      "MN": "Minnesota",
      "MS": "Mississippi",
      "MO": "Missouri",
      "MT": "Montana",
      "NE": "Nebraska",
      "NV": "Nevada",
      "NH": "New Hampshire",
      "NJ": "New Jersey",
      "NM": "New Mexico",
      "NY": "New York",
      "NC": "North Carolina",
      "ND": "North Dakota",
      "OH": "Ohio",
      "OK": "Oklahoma",
      "OR": "Oregon",
      "PA": "Pennsylvania",
      "RI": "Rhode Island",
      "SC": "South Carolina",
      "SD": "South Dakota",
      "TN": "Tennessee",
      "TX": "Texas",
      "UT": "Utah",
      "VT": "Vermont",
      "VA": "Virginia",
      "WA": "Washington",
      "WV": "West Virginia",
      "WI": "Wisconsin",
      "WY": "Wyoming"
    },
    "sort": {
      "nameAsc": "Name (A–Z)",
      "nameDesc": "Name (Z–A)",
      "newest": "Newest",
      "oldest": "Oldest"
    }
  },
  "validation": {
    "required": "{field} is required",
    "email": "Invalid email address",
    "url": "Invalid URL",
    "minValue": "Must be at least {min}",
    "positiveInteger": "{field} must be a positive whole number",
    "positiveNumber": "{field} must be greater than zero",
    "rangeOrder": "The latest value cannot be before the earliest",
    "phoneE164": "Not a valid mobile number (e.g. 514 555-0123). Extensions and notes belong in the phone field."
  },
  "more": {
    "title": "More",
    "subtitle": "Directories and team.",
    "companies": "Companies",
    "companiesDesc": "Browse commercial clients & partners.",
    "crew": "My Crew",
    "crewDesc": "Squads you belong to and their members."
  },
  "crew": {
    "empty": "You're not part of any squad yet.",
    "you": "you",
    "usualTarget": "Usually aims for {value}"
  },
  "vehicles": {
    "title": "Vehicles",
    "subtitle": "Manage your fleet of trucks and vans.",
    "addVehicle": "Add Vehicle",
    "addTitle": "Add Vehicle",
    "createSuccess": "Vehicle added.",
    "updateSuccess": "Vehicle updated.",
    "deleteSuccess": "Vehicle removed.",
    "deleteConfirmTitle": "Remove vehicle?",
    "deleteConfirmDescription": "Remove {name} from your fleet? This can't be undone.",
    "searchPlaceholder": "Search vehicles",
    "emptyTitle": "No vehicles yet",
    "tabs": {
      "all": "All",
      "active": "Active",
      "inactive": "Inactive"
    },
    "fields": {
      "name": "Name",
      "namePlaceholder": "e.g. Truck 1 — Ford Transit",
      "status": "Status",
      "active": "Active"
    }
  },
  "depots": {
    "hqRow": "Head office",
    "hqFallback": "Default start and end",
    "title": "Depots",
    "addDepot": "Add depot",
    "createNamed": "Add the depot “{name}”",
    "addTitle": "Add depot",
    "createSuccess": "Depot added.",
    "updateSuccess": "Depot updated.",
    "deleteSuccess": "Depot removed.",
    "deleteConfirmTitle": "Remove depot?",
    "deleteConfirmDescription": "Remove {name}? Past plans that used it stay unchanged.",
    "emptyTitle": "No depots yet",
    "geocode": {
      "pending": "Locating…",
      "succeeded": "Located",
      "failed": "Not found"
    },
    "fields": {
      "name": "Name",
      "namePlaceholder": "e.g. Marc's home",
      "address": "Address",
      "addressPlaceholder": "e.g. 123 Rue Principale, Québec",
      "location": "Location"
    },
    "searchPlaceholder": "Search depots"
  },
  "weather": {
    "conditions": {
      "rain": "Rain",
      "wind": "Wind",
      "frost": "Frost",
      "heat": "Heat"
    },
    "direction": {
      "above": "above",
      "below": "below"
    },
    "errors": {
      "valueRequired": "Set a value",
      "outOfRange": "Must be between {min} and {max}"
    },
    "settings": {
      "title": "Weather",
      "hint": "Default thresholds. They make nothing sensitive on their own: sensitivity is declared on the step or on the job type.",
      "attribution": "Forecasts from Environment Canada. No customer address is ever sent."
    },
    "sensitivity": {
      "blankUsesDefault": "Blank = the shop's threshold."
    },
    "type": {
      "title": "Default weather limits",
      "none": "None"
    },
    "outlook": {
      "title": "This morning",
      "notConfigured": "No weather limits are set yet, so nothing can be flagged.",
      "configureLink": "Set them on a job type",
      "noConfirmedDay": "No confirmed day today.",
      "stops": "{count} stop | {count} stops",
      "aboveThreshold": "{count} above its limit | {count} above their limit",
      "clear": "Nothing above a limit",
      "peakRain": "Rain up to {value} % at {at}",
      "peakWind": "Wind up to {value} {unit} at {at} (gusts {gust})",
      "rainScale": "Rain probability",
      "unknownHour": "no forecast",
      "partialCoverage": "Incomplete data for part of the day.",
      "unknownHourStops": "{count} stop not judged | {count} stops not judged",
      "showHours": "Show the hours",
      "hideHours": "Hide the hours",
      "gustShort": "gusts {value}",
      "noForecastInWindow": "No forecast for your working hours"
    },
    "cell": {
      "chipRisk": "{lop} % from {from} · {count} at risk",
      "chipRiskNoHour": "{lop} % · {count} at risk",
      "chipQuiet": "{lop} % · {count} to check",
      "chipQuietNoLop": "{count} to check",
      "popoverTitle": "Rain · {date}",
      "threshold": "stops' limit: {lop} %",
      "verdictAtRisk": "{value} % · limit {threshold}",
      "verdictAtRiskOther": "over the limit",
      "verdictSafe": "fine",
      "verdictUnjudged": "to check",
      "stopAtRisk": "Rain over this stop's limit"
    },
    "org": {
      "chipConfigure": "Set weather limits",
      "chipTimeZone": "Set the time zone",
      "chipUnavailable": "Weather unavailable",
      "chipNoWindow": "No forecast in working hours"
    }
  },
  "maps": {
    "locationTitle": "Location",
    "snapshotAlt": "Map of the location",
    "dayOverviewAlt": "Map of the day's stops, numbered in route order"
  },
  "customers": {
    "customer": "Customer",
    "pickPlaceholder": "Search for a customer",
    "newAddress": "New address",
    "newTitle": "New customer",
    "siteContact": "Site contact",
    "dedup": {
      "geocoding": "Locating the address…",
      "placeFound": "We already have an address here:",
      "currently": "currently {name}",
      "useLocation": "Use this location",
      "newLocation": "No, new location",
      "usingLocation": "Existing location: {name}",
      "newLocationConfirmed": "New location confirmed",
      "geocodeFailed": "Address not located — no duplicate check",
      "cellFound": "This number is on file for {name}.",
      "itsThem": "It's {name}",
      "releaseNumber": "New owner — remove it from their file",
      "usingContact": "Existing customer: {name}",
      "numberReleased": "The number will be moved from {name} to this customer",
      "change": "change"
    },
    "optional": "optional",
    "kind": {
      "contact": "Individual",
      "company": "Company"
    }
  },
  "addressLookup": {
    "locating": "Locating the address…",
    "weakGrade": "≈ centre of the lot",
    "choose": "{count} addresses match",
    "askStreet": "Add the street: the postal code alone does not settle {number}",
    "notFound": "No address found",
    "createUnlocated": "Create without a location",
    "saveUnlocated": "Save without a location",
    "willCreateUnlocated": "Will be created without a location",
    "willSaveUnlocated": "Will be saved without a location",
    "unavailable": "Location lookup unavailable for now",
    "withoutPostal": "Street and city",
    "postalOnly": "Postal code only",
    "change": "change",
    "validation": {
      "civicNumberRequired": "Civic number required",
      "postalIncomplete": "Incomplete postal code",
      "cityOrPostalRequired": "City or postal code required"
    }
  },
  "serviceLocations": {
    "title": "Service Locations",
    "geocodeFailed": "Geocoding failed",
    "addLocation": "Add Location",
    "editTitle": "Edit Location",
    "editDescription": "Update the address or details for this location.",
    "createDescription": "Add a service address for this contact.",
    "createSuccess": "Location added.",
    "updateSuccess": "Location updated.",
    "deleteSuccess": "Location removed.",
    "deleteConfirmTitle": "Remove Location?",
    "deleteConfirmDescription": "Are you sure you want to remove \"{name}\"? Jobs at this location will not be affected.",
    "unnamed": "Unnamed Location",
    "noLocationsForContact": "No locations yet for this contact.",
    "navTitle": "Locations",
    "searchPlaceholder": "Search by customer or address",
    "noLocations": "No locations yet.",
    "customer": "Customer",
    "noCustomer": "No customer",
    "createdOn": "Created",
    "company": "Company",
    "noCompany": "No company",
    "noContact": "No site contact",
    "notFound": "Location not found.",
    "viewRecord": "View record",
    "fields": {
      "name": "Location Name",
      "namePlaceholder": "e.g. Warehouse, Unit 4B (optional)",
      "address_line1": "Street Address",
      "civicNumber": "Civic no.",
      "street": "Street",
      "city": "City",
      "province": "Province",
      "state": "State",
      "provinceState": "Province / State",
      "postal_code": "Postal Code",
      "country": "Country",
      "notes": "Access Notes",
      "notesPlaceholder": "Gate code, parking instructions, etc.",
      "siteContact": "Site contact",
      "person": "Person",
      "noSiteContact": "None"
    },
    "detailsTitle": "Address",
    "deleteTitle": "Delete address"
  },
  "invitations": {
    "accept": {
      "title": "Accept Invitation",
      "subtitle": "Create your account to join your team on Vitesse.",
      "action": "Create Account & Login",
      "success": "Welcome aboard! Your account has been created.",
      "invalidToken": "The invitation link is invalid or has expired."
    }
  },
  "errors": {
    "validation": {
      "required": "This field is required.",
      "email": "Please enter a valid email address.",
      "passwordMin": "Password must be at least 8 characters long.",
      "passwordMismatch": "Passwords do not match."
    },
    "api": {
      "default": "An unexpected error occurred. Please try again.",
      "unexpected_format": "The server returned an unexpected error format.",
      "LOGIN_FAILED": "Invalid email or password.",
      "UNAUTHORIZED": "You are not authorized to perform this action.",
      "FORBIDDEN": "You do not have permission to access this resource.",
      "RECORD_NOT_UNIQUE": "This record could not be saved because it already exists.",
      "SQUAD_VEHICLE_TAKEN": "This truck already belongs to another team. Release it there first.",
      "VEHICLE_DAY_TAKEN": "Another crew already has this truck on this day.",
      "SQUAD_LEAD_TAKEN": "A team can only have one lead.",
      "SQUAD_MEMBER_DUPLICATE": "This person already holds that role with that trade on the team.",
      "NO_TARGET": "Set a day target (or a default on the crew) so the suggestion knows when to stop.",
      "LANE_OFF": "Wrong unit for this crew: a quotes crew composes its day in stops, a treatment crew in dollars.",
      "NOTHING_TO_PROPOSE": "Nothing to propose — no waiting work fits this crew and day."
    }
  },
  "migrations": {
    "title": "Housecall Pro migration",
    "answers": {
      "untyped": "No type",
      "skip": "Don't import"
    },
    "files": {
      "customers": "Customers",
      "jobs": "Jobs",
      "estimates": "Estimates",
      "required": "required",
      "uploading": "Uploading",
      "wrongFile": "This file is not that Housecall export",
      "remove": "Remove the file",
      "browse": "Browse",
      "verify": "Check",
      "megabytes": "{n} MB",
      "kilobytes": "{n} KB"
    },
    "refusals": {
      "customers_file_required": "The customers file is required",
      "jobs_or_estimates_required": "Add the jobs or the estimates",
      "open_run": "A migration is already under way",
      "invalid_state": "This migration changed in the meantime",
      "invalid_answer": "An answer does not name a job type",
      "scan_failed": "The files could not be read",
      "unknown": "The migration could not start"
    },
    "types": {
      "search": "Search a service",
      "names": "{n} name | {n} names",
      "columns": {
        "name": "Service",
        "rows": "Rows",
        "year": "Year",
        "answer": "Answer"
      },
      "selected": "{n} selected | {n} selected",
      "assignTo": "Assign to",
      "pickType": "Job type",
      "blank": "(no description)",
      "answered": "{n} name already answered | {n} names already answered",
      "continue": "Continue",
      "jobs": "{n} job | {n} jobs",
      "estimates": "{n} est. | {n} est.",
      "footer": {
        "rows": "{n} row | {n} rows",
        "types": "{n} type | {n} types",
        "untyped": "{n} with no type",
        "skipped": "{n} not imported | {n} not imported"
      }
    },
    "working": {
      "scanning": "Reading the services",
      "verifying": "Checking",
      "writing": "Writing",
      "stages": {
        "customers": "Customers",
        "jobs": "Jobs",
        "estimates": "Estimates",
        "seasons": "Seasons"
      },
      "elapsed": "under a minute | {n} min | {n} min"
    },
    "report": {
      "inFlight": "Work in progress",
      "toPlan": "{n} job to plan | {n} jobs to plan",
      "byType": "By type",
      "columns": {
        "type": "Type",
        "jobs": "Jobs",
        "billed": "$ billed",
        "estimates": "Estimates",
        "quoted": "$ quoted"
      },
      "imported": "Imported",
      "notImported": "Not imported",
      "customersAndEstimates": "Customers and estimates",
      "customersCreated": "Customers created",
      "customersUpdated": "Customers updated",
      "customersUnchanged": "Customers unchanged",
      "estimatesMatched": "Estimates joined to their job",
      "estimatesLost": "Estimates lost",
      "estimatesCancelled": "Sold, never billed → cancelled",
      "seasons": "Seasons",
      "seasonsSkipped": "No season years were given: a season spans two years.",
      "undecided": "Jobs to settle (a type with two seasons)",
      "yearsClosed": "{n} year closed | {n} years closed",
      "yearState": {
        "idle": "{year} not opened",
        "open": "{year} open"
      },
      "waiting": "{n} job waits | {n} jobs wait",
      "notBuiltOn": "Not handled",
      "unhandledStatus": "Unhandled statuses « {column} »",
      "ignoredColumns": "Ignored columns · {file}",
      "leftAside": "Left aside",
      "aside": {
        "live": "Jobs scheduled after the export",
        "unresolved": "Unresolved identities",
        "no_address": "No address",
        "estimates_ambiguous": "Ambiguous estimates",
        "estimates_on_skipped_job": "Estimates of a job not imported",
        "estimates_live": "Estimates scheduled after the export",
        "skipped_kept": "Already imported, kept",
        "estimates_in_flight_superseded": "Work in progress billed since",
        "estimates_in_flight_worked": "Work in progress worked here",
        "estimates_in_flight_aged_worked": "Work in progress aged out, worked here",
        "cells_withheld": "Cell numbers withheld",
        "failures": "Failures"
      },
      "capped": "first {shown} of {total}",
      "changeTypes": "Change the types",
      "import": "Import",
      "filesOf": "Files of {date}"
    },
    "status": {
      "pending": "Reading",
      "scanning": "Reading",
      "typing": "Types to answer",
      "verifying": "Checking",
      "verified": "Checked",
      "writing": "Writing",
      "written": "Written",
      "failed": "Failed",
      "abandoned": "Abandoned"
    },
    "failed": {
      "retry": "Retry the write",
      "staleTemplate": "A job type answered was deleted since. Answer the types again.",
      "interrupted": "The migration was interrupted.",
      "generic": "The migration failed."
    },
    "toast": {
      "written": "Migration written | Migration written · {n} address to locate | Migration written · {n} addresses to locate"
    },
    "section": {
      "title": "Migrations",
      "customers": "Customers",
      "jobs": "Jobs",
      "estimates": "Estimates"
    }
  },
  "imports": {
    "steps": {
      "upload": "Upload",
      "mapping": "Map Columns",
      "preview": "Preview",
      "result": "Result"
    },
    "upload": {
      "templateHint": "Need a template? Download the starter CSV.",
      "downloadTemplate": "Download template",
      "dropzone": "Drop your file here, or click to browse",
      "acceptedFormats": "Accepted: .csv, .xlsx, .xls, .ods",
      "limits": "Up to {mb} MB and {rows} rows",
      "rejectedType": "That file type is not accepted. Formats: {formats}",
      "rejectedSize": "That file is larger than {max} MB.",
      "uploading": "Uploading... {pct}%"
    },
    "groups": {
      "contact": "Contact",
      "primaryAddress": "Primary Address",
      "company": "Company",
      "part": "Item"
    },
    "mapping": {
      "instructions": "Match each column from your file to the corresponding field in Vitesse.",
      "csvColumn": "File Column",
      "mapsTo": "Vitesse Field",
      "sheet": "Sheet",
      "skip": "Skip (ignore)",
      "optional": "optional",
      "contested": "Two fields point at the same column: {columns}",
      "ignored": "{count} column(s) in the file will not be imported: {columns}",
      "preview": "Preview →"
    },
    "preview": {
      "rowCount": "{count} rows in this file",
      "invalidCount": "{count} unreadable",
      "duplicateCount": "{count} rows match a record already on file",
      "matchedBy": "Matched by {key}",
      "blankColumns": "{count} unnamed column(s) ignored",
      "renamedColumns": "Repeated columns renamed: {names}",
      "importButton": "Import {count} rows",
      "nothingToWrite": "Nothing would be written with these settings.",
      "actions": {
        "create": "Create",
        "update": "Update",
        "skip": "Skip",
        "error": "Error"
      },
      "strategies": {
        "skip": "Skip",
        "update": "Update",
        "create_anyway": "Create anyway"
      },
      "strategyHints": {
        "skip": "Records already on file are left untouched.",
        "update": "Filled cells overwrite; a blank cell never erases anything.",
        "create_anyway": "A second record is created for every match."
      },
      "keys": {
        "email": "email",
        "sku": "SKU",
        "company_name": "company name",
        "in_file": "another row in the same file"
      }
    },
    "report": {
      "title": "Import report",
      "groups": {
        "failed": "Failed",
        "skipped": "Skipped",
        "flagged": "To check"
      },
      "shown": "{shown} rows shown of {total}",
      "row": "Row",
      "status": "Result",
      "problem": "Problem"
    },
    "flags": {
      "weak_duplicate": "May already be on file",
      "ambiguous_duplicate": "Matches more than one existing record",
      "cell_claimed_elsewhere": "This mobile number is on another contact's file",
      "duplicate": "Already on file",
      "unknown": "See the downloaded report for details"
    },
    "examples": {
      "first_name": "Marie",
      "last_name": "Tremblay",
      "email": "marie.tremblay{'@'}example.com",
      "phone": "418 555-0123",
      "cell_phone": "418 555-0199",
      "job_title": "Owner",
      "address_line1": "130 Wolfe St",
      "city": "Levis",
      "province": "QC",
      "postal_code": "G6V 3Z4",
      "country": "Canada",
      "company_name": "Rive-Sud Landscaping Inc.",
      "website": "example.com",
      "notes": "Customer since 2019",
      "name": "Fertilizer 20-0-5",
      "sku": "FRT-2005",
      "unit_price": "24.99",
      "cost_price": "12.50",
      "unit": "bag",
      "job_template": "Fertilizing",
      "taxable": "yes",
      "description": "20 kg bag"
    },
    "result": {
      "processing": "Importing your file…",
      "processingNote": "This may take a moment. Please wait.",
      "progress": "{done} of {total}",
      "safeToClose": "You can close this window — the import keeps going.",
      "done": "Import complete",
      "created": "{count} records created",
      "updated": "{count} records updated",
      "skipped": "{count} rows already on file",
      "flagged": "{count} rows to check",
      "failed": "{count} rows with errors",
      "another": "Import another file",
      "resume": "Resume",
      "downloadFailed": "Download report",
      "rowLabel": "Row {n}",
      "moreErrors": "+{count} more — see report",
      "error": "Import failed",
      "unknownError": "An unexpected error occurred. Please try again.",
      "close": "Done"
    },
    "fields": {
      "first_name": "First Name",
      "last_name": "Last Name",
      "email": "Email",
      "phone": "Phone",
      "cell_phone": "Mobile",
      "job_title": "Job Title",
      "address_line1": "Street Address",
      "city": "City",
      "province": "Province / State",
      "postal_code": "Postal Code",
      "country": "Country",
      "name": "Name",
      "sku": "SKU",
      "unit_price": "Unit Price",
      "cost_price": "Cost Price",
      "unit": "Unit",
      "job_template": "Job type",
      "taxable": "Taxable",
      "description": "Description",
      "company_name": "Company Name",
      "website": "Website",
      "notes": "Notes"
    },
    "notifications": {
      "done": "{type} import complete — {count} records created",
      "failed": "{type} import failed — check import history for details"
    },
    "history": {
      "title": "Import History",
      "unknownType": "Unknown",
      "emptyTitle": "No imports yet",
      "kinds": {
        "contact": "Contacts",
        "company": "Companies",
        "part": "Items"
      },
      "columns": {
        "content": "Content",
        "status": "Status",
        "date": "Date",
        "created": "Created",
        "failed": "Errors",
        "by": "By"
      },
      "statuses": {
        "pending_mapping": "Pending",
        "dry_running": "Checking",
        "processing": "Processing",
        "done": "Done",
        "failed": "Failed"
      }
    },
    "viewHistory": "View import history",
    "contact": {
      "title": "Import Contacts"
    },
    "part": {
      "title": "Import Parts"
    },
    "company": {
      "title": "Import Companies"
    }
  },
  "notifications": {
    "hub": {
      "title": "Notifications",
      "subtitle": "Choose which notifications you receive and where.",
      "updateError": "Couldn't update your notification preference.",
      "categories": {
        "my_day": "My day",
        "field": "Field",
        "money": "Money",
        "sales": "Sales",
        "notes": "Notes",
        "imports": "Imports"
      },
      "channels": {
        "web": "Web",
        "mobile": "Mobile"
      },
      "types": {
        "route_changed": {
          "label": "Day changed",
          "description": "The office changed your day today: a stop removed, deferred, cancelled, or the day re-confirmed"
        },
        "job_complete": {
          "label": "Work completed",
          "description": "The crew finished a job's last visit — it's ready to invoice"
        },
        "field_dropped": {
          "label": "Stops dropped by the field",
          "description": "A crew removed a stop promised for today, emptied its day or cancelled it — customers to call"
        },
        "proposal_accepted": {
          "label": "Quote accepted",
          "description": "A customer signed a quote, or the office recorded a yes"
        },
        "proposal_declined": {
          "label": "Quote declined",
          "description": "A quote has been declined"
        },
        "proposal_expired": {
          "label": "Quotes expired",
          "description": "A summary at opening: the quotes you sent that expired since the last open day"
        },
        "import_complete": {
          "label": "Import finished",
          "description": "An import you started has finished"
        },
        "day_cancelled": {
          "label": "Day cancelled",
          "description": "When your day is called off (weather, breakdown, crew unavailable)"
        },
        "day_unclosed": {
          "label": "Day to close out",
          "description": "At end of shift, when stops of your day still have no verdict (crew lead)"
        },
        "note_mention": {
          "label": "Mentioned in a note",
          "description": "Someone names you ({'@'}) in a note"
        },
        "invoice_paid": {
          "label": "Payment received",
          "description": "A customer paid an invoice online"
        },
        "payment_problem": {
          "label": "Payment problem",
          "description": "Online payments were suspended, a debit failed, or a payment could not be recorded"
        }
      }
    }
  },
  "push": {
    "notification": {
      "fallbackTitle": "New notification",
      "view": "View"
    }
  },
  "fleet": {
    "title": "Teams",
    "crewColumn": "Team",
    "noTruck": "No truck",
    "lanes": {
      "work": "Work",
      "quotes": "Quotes"
    },
    "crew": {
      "notFound": "This team no longer exists.",
      "hours": "Hours",
      "followsOrgHours": "Organization hours",
      "dayOff": "Off",
      "composer": "Composer",
      "fill": "Filling",
      "fillAuto": "Automatic",
      "manualOnly": "Manual only",
      "breakRead": "{minutes} min break",
      "sections": {
        "work": "The work",
        "day": "The day"
      },
      "perDay": "per day",
      "moreTypes": "{count} more | {count} more | {count} more",
      "showLess": "Show less",
      "removeMember": "Remove from team",
      "delete": "Delete team",
      "noTruck": "No truck",
      "searchTrade": "Search a trade"
    },
    "columns": {
      "lane": "Lane",
      "truck": "Truck",
      "members": "Members",
      "dayTarget": "Day target",
      "depots": "Depots"
    },
    "tabs": {
      "vehicles": "Trucks",
      "squads": "Teams",
      "depots": "Depots"
    }
  },
  "invoices": {
    "paidVia": {
      "pickTitle": "How was {number} paid?",
      "confirmTitle": {
        "interac": "Mark {number} paid by Interac e-Transfer?",
        "cheque": "Mark {number} paid by cheque?",
        "cash": "Mark {number} paid in cash?",
        "card": "Mark {number} paid by card?",
        "other": "Mark {number} paid (other method)?"
      },
      "methods": {
        "interac": "Interac e-Transfer",
        "cheque": "Cheque",
        "cash": "Cash",
        "card": "Card",
        "other": "Other"
      }
    },
    "timeline": {
      "created": "Invoice created",
      "issued": "Invoice {number} issued",
      "sentBy": "Invoice sent by {channel}",
      "reminded": "Follow-up recorded",
      "paid": "Invoice {number} paid",
      "uncollectible": "Invoice {number} written off",
      "voided": "Invoice {number} voided"
    },
    "title": "Billing",
    "states": {
      "draft": "Draft",
      "issued": "Issued",
      "paid": "Paid",
      "void": "Voided",
      "uncollectible": "Uncollectible"
    },
    "card": {
      "invoiceAction": "Invoice",
      "count": "{n} invoice | {n} invoice | {n} invoices",
      "empty": "No invoices yet.",
      "emptyHint": "Invoices are born from a signed section, the whole proposal, or free-form lines.",
      "draftTitle": "Draft",
      "alreadyBilled": "Already billed",
      "sourceProposal": "Invoice the whole proposal",
      "sourceProposalFor": "Invoice the whole proposal ({number})",
      "sourceCustom": "Free-form invoice",
      "sourceEvaluation": "Evaluation"
    },
    "summary": {
      "proposalsToBill": "Proposal not billed | {n} proposals not billed",
      "awaitingPayment": "{n} invoice awaiting payment | {n} invoices awaiting payment",
      "uncollectible": "{n} invoice written off | {n} invoices written off",
      "allPaid": "Everything is billed and paid"
    },
    "row": {
      "open": "Open",
      "actionsTitle": "Invoice {label}"
    },
    "editor": {
      "frozenOn": "Invoice issued on {date} — frozen document",
      "frozen": "Frozen document",
      "title": "Invoice {number}",
      "draftTitle": "Draft invoice",
      "titleLabel": "Title",
      "titlePlaceholder": "e.g. Visit 2 — hedge trimming",
      "name": "Description",
      "namePlaceholder": "Line description",
      "quantity": "Qty",
      "unitPrice": "Unit price",
      "unitTag": "Unit: {unit}",
      "discountTag": "Discount −{percent} %",
      "taxableShort": "Tax",
      "addLine": "Add a line",
      "subtotal": "Subtotal",
      "discount": "Discount",
      "taxes": "Taxes",
      "total": "Total",
      "needLineHint": "Add at least one line to issue.",
      "nameRequiredHint": "Every line needs a name.",
      "regenerate": "Regenerate the link",
      "regenerateConfirmTitle": "Regenerate the public link?",
      "regenerateConfirmBody": "Every link already shared for this invoice will stop working. Email and copy will use the new link.",
      "issue": "Issue",
      "issueConfirmTitle": "Issue this invoice?",
      "issueConfirmBody": "A number will be assigned and the invoice will no longer be editable.",
      "markPaid": "Mark paid",
      "markUncollectible": "Uncollectible",
      "markUncollectibleConfirmTitle": "Mark this invoice uncollectible?",
      "markUncollectibleConfirmBody": "The debt is written off, but invoice {number} and its link remain — a late payment can still mark it paid.",
      "markPaidConfirmBody": "The payment will be recorded as of today.",
      "void": "Void invoice",
      "voidConfirmTitle": "Void this invoice?",
      "voidConfirmBody": "Number {number} stays burned. A new invoice can be issued.",
      "delete": "Delete",
      "deleteConfirmTitle": "Delete this draft?",
      "deleteConfirmBody": "This draft will be permanently deleted.",
      "issuedOn": "Issued {date}",
      "paidOn": "Paid {date}",
      "notFound": "Invoice not found.",
      "retry": "Retry",
      "copyLink": "Copy link",
      "sendEmail": "Send by email",
      "downloadPdf": "Download the PDF"
    },
    "evaluation": {
      "chip": "Evaluation invoice",
      "notBilled": "Evaluation not billed",
      "create": "Bill the evaluation ({amount})",
      "freeSigned": "The customer signed — the evaluation is free.",
      "signedWarning": "The customer signed — the evaluation is free for them. Void this invoice or refund it."
    },
    "toasts": {
      "draftCreated": "Draft invoice created.",
      "issued": "Invoice {number} issued.",
      "paid": "Invoice marked paid.",
      "voided": "Invoice voided.",
      "uncollectible": "Invoice marked uncollectible.",
      "deleted": "Draft deleted.",
      "linkCopied": "Link copied.",
      "linkRegenerated": "New link created — every shared link is now dead.",
      "emailSent": "Invoice sent by email.",
      "pdfUnavailable": "The PDF is not available right now."
    }
  },
  "signaturePad": {
    "signHere": "Sign here",
    "clear": "Clear",
    "caption": "Customer signature (finger or stylus)"
  },
  "publicProposal": {
    "loading": "Loading…",
    "greetingName": "Hello {name},",
    "intro": "Here is our quote. You can review it and sign online.",
    "introWithAddress": "Here is our quote for the work at {address}. You can review it and sign online.",
    "facts": {
      "number": "Quote",
      "issued": "Issued",
      "validUntil": "Valid until"
    },
    "rbq": "RBQ {number}",
    "footerQuestions": "Questions? {phone}",
    "subtotal": "Subtotal",
    "discount": "Discount",
    "taxes": "Taxes",
    "total": "Total",
    "unnamedItem": "Item",
    "optionalItem": "optional",
    "itemsCount": "{n} item | {n} items",
    "acceptCta": "Accept and sign",
    "copyNotice": "A PDF copy will be sent to you after signing.",
    "signingTitle": "Confirm your acceptance",
    "confirmAmount": "Confirm — {amount}",
    "legal": "By signing, you accept quote {number}.",
    "submitting": "Sending…",
    "submitError": "Something went wrong — please try again or call us.",
    "signed": {
      "title": "Thank you! Your acceptance is recorded.",
      "signedOn": "Signed on {date}",
      "copyLabel": "Your copy of the contract",
      "copyPreparing": "Your PDF copy is being prepared…",
      "downloadPdf": "Download the PDF",
      "nextLabel": "What happens next",
      "stepContact": "We contact you to schedule the work",
      "stepWork": "The work is done",
      "stepWorkSub": "On the dates agreed with you",
      "signedTag": "Signed",
      "yourDocument": "Your quote"
    },
    "revised": {
      "title": "This quote has been revised",
      "body": "A new version is being prepared. Please contact us for the latest one."
    },
    "expired": {
      "title": "This quote is no longer available",
      "body": "Please contact us to receive an up-to-date version."
    },
    "superseded": {
      "title": "This quote has been replaced",
      "body": "This work was confirmed another way. Please contact us with any questions."
    },
    "notFound": {
      "title": "This link is not valid",
      "body": "Please check the link you received, or contact us."
    },
    "signingDocument": "Quote “{name}”"
  },
  "members": {
    "title": "Members",
    "invite": "Invite a member",
    "inviteSubmit": "Invite",
    "empty": "No members.",
    "you": "you",
    "invitationPending": "Invitation sent on {date}",
    "resend": "Resend invitation",
    "revoke": "Remove access",
    "revokeConfirmTitle": "Remove access?",
    "revokeConfirmDescription": "{name} will no longer be able to sign in to your organization. Their history stays visible.",
    "inviteSentSuccess": "Invitation sent.",
    "accessGrantedSuccess": "Access granted — this person already had an account.",
    "roleChangedSuccess": "Role changed.",
    "revokeSuccess": "Access removed.",
    "resendSuccess": "Invitation resent.",
    "columns": {
      "person": "Person",
      "role": "Role"
    },
    "roles": {
      "member": "Member",
      "admin": "Administrator",
      "owner": "Owner"
    },
    "fields": {
      "email": "Email",
      "emailHint": "An existing account is attached without an email; a new one receives an invitation.",
      "firstName": "First name",
      "lastName": "Last name",
      "role": "Role"
    }
  },
  "closures": {
    "title": "Closures",
    "hint": "The days the company is closed, whatever the weekday. The composer skips them; placing work by hand stays possible.",
    "addNew": "New closure",
    "edit": "Edit closure",
    "empty": "No upcoming closure.",
    "emptyHint": "A statutory holiday, the construction holiday, a company day.",
    "showPast": "Show past closures",
    "hidePast": "Hide past closures",
    "createSuccess": "Closure added.",
    "updateSuccess": "Closure updated.",
    "deleteSuccess": "Closure removed.",
    "deleteConfirmTitle": "Remove the closure?",
    "deleteConfirmDescription": "“{name}” becomes a working day again.",
    "fields": {
      "date": "Date",
      "name": "Reason",
      "namePlaceholder": "e.g. Christmas, Fête nationale, construction holiday"
    }
  },
  "workPeriods": {
    "title": "Seasons",
    "empty": {
      "declarable": "No season — work is possible year-round."
    },
    "addSeason": "New season",
    "edit": "Edit",
    "editTitle": "Edit — {name}",
    "page": {
      "closeFirst": "Close {label} first",
      "delete": "Delete",
      "openedOn": "Opened on",
      "closedOn": "Closed on",
      "composer": "Composer",
      "composerUntil": "until {date}",
      "composerFrom": "from {date}",
      "composerBetween": "from {from} to {until}",
      "composerStopped": "stopped on {date}",
      "composerNoCeiling": "no limit",
      "composerClosed": "nothing more will be proposed",
      "jobs": "Jobs",
      "jobsWaiting": "Jobs waiting",
      "unserved": "Visits to deliver",
      "leadsUnsold": "Unsold quotes",
      "renewable": "Renewable",
      "leadsToTransfer": "Quotes to renew",
      "noRun": "No job has asked for this season yet."
    },
    "fields": {
      "name": "Name",
      "opens": "From",
      "closes": "To",
      "wrapsYear": "This season straddles two years"
    },
    "deleteTitle": "Delete this period?",
    "deleteHint": "Types attached to it become possible year-round again. Refused while a year carries jobs.",
    "createSuccess": "Period created",
    "updateSuccess": "Period updated",
    "deleteSuccess": "Period deleted",
    "months": {
      "1": "Jan",
      "2": "Feb",
      "3": "Mar",
      "4": "Apr",
      "5": "May",
      "6": "Jun",
      "7": "Jul",
      "8": "Aug",
      "9": "Sep",
      "10": "Oct",
      "11": "Nov",
      "12": "Dec"
    },
    "errors": {
      "day": "Between 1 and 31",
      "notADate": "That day does not exist in that month"
    },
    "onType": {
      "title": "Seasons",
      "noneDefined": "No season defined yet.",
      "defineLink": "Create one",
      "yearRound": "Year-round",
      "seasons": "Seasons",
      "seasonsHint": "The seasons this type is sold into."
    },
    "typeWindows": {
      "work": "Work",
      "evaluation": "Evaluations",
      "line": {
        "wholeSeason": "Whole season",
        "wholeSeasonAtOpening": "Whole season · dates at opening",
        "wholeSeasonBetween": "Whole season · {from} → {until}",
        "wholeSeasonFrom": "Whole season · from {from}",
        "wholeSeasonUntil": "Whole season · until {until}",
        "between": "{from} → {until}",
        "from": "from {from}",
        "until": "until {until}",
        "starts": "Starts {from}",
        "ended": "Ended {until}",
        "empty": "empty window · nothing will be proposed"
      },
      "setBy": "set by {name} on {date}",
      "popoverTitle": "{name} · {season}",
      "likeLastYear": "Same as {year}",
      "blankIsSeason": "Blank = like the season ({range})",
      "likeSeason": "Like the season",
      "saved": "{name} dates saved"
    },
    "seasonTypes": {
      "title": "Job types",
      "none": "No type",
      "add": "Add a type",
      "remove": "Remove {name}"
    },
    "tags": {
      "open": "Open",
      "ceiling_passed": "Composer stopped",
      "idle": "Waiting",
      "closed": "Closed",
      "none": "None"
    },
    "verbs": {
      "openYear": "Open {label}",
      "reopen": "Reopen",
      "close": "Close",
      "editWindow": "edit",
      "openSeason": "Open the {label} season",
      "startCampaign": "Start the campaign",
      "endCampaign": "End the campaign"
    },
    "year": {
      "campaign": "Campaign",
      "season": "Season",
      "campaignState": {
        "not_started": "Not started",
        "live": "Running",
        "ended": "Ended"
      },
      "campaignLine": {
        "not_started": "Campaign not started",
        "live": "Campaign running",
        "ended": "Campaign ended"
      },
      "seasonState": {
        "idle": "Not open",
        "open": "Open",
        "ceiling_passed": "Open · composer stopped",
        "closed": "Closed"
      },
      "on": "on {date}",
      "onBy": "on {date} by {who}",
      "toCall": "{n} to call",
      "callList": "Call list",
      "notNext": "The next campaign is {label}",
      "endFirst": "End the {label} campaign first",
      "noYet": "No job for this year yet."
    },
    "runs": {
      "fields": {
        "year": "Year",
        "closedOn": "Closed on",
        "composeFrom": "Compose from",
        "composeUntil": "to"
      },
      "openTitle": "Open {name} {label}",
      "openVerb": "Open {name} {label}",
      "openSuccess": "Season {label} opened",
      "closeTitle": "Close {name} {label}?",
      "closeSub": "Here is what closing changes.",
      "closeVerb": "Close {name} {label}",
      "closeSuccess": "Season {label} closed",
      "closeLeadsRenewed": "{count} quote moved to {next} | {count} quotes moved to {next}",
      "closeLeadsLost": "{count} quote marked lost | {count} quotes marked lost",
      "unsoldLeads": {
        "title": "Its unsold quote: | Its {count} unsold quotes:",
        "renew": "Renew for {name} {next}",
        "lose": "Mark lost | Mark lost",
        "keep": "Leave on {name} {label}"
      },
      "nextCampaign": {
        "title": "The {name} {next} campaign:",
        "start": "Start now",
        "startCount": "Start now ({count} to call)",
        "later": "Later"
      },
      "reopenSuccess": "Season {label} reopened",
      "endCampaignSuccess": "Campaign {label} ended.",
      "startCampaignSuccess": "Campaign {label} started.",
      "reopenTitle": "Reopen {name} {label}?",
      "reopenSub": "Here is what reopening changes.",
      "reopenVerb": "Reopen {name} {label}",
      "windowTitle": "Composer — {name} {label}",
      "windowSuccess": "Composer dates updated",
      "shorteningWarning": "Narrowing the interval removes the stops already proposed outside it from the composer. Confirmed days do not move.",
      "optional": "optional",
      "consequences": {
        "confirmedUntouched": "Days already confirmed do not move.",
        "closeUnserved": "{count} undelivered visit is marked “Season over”. It stays owed and visible on its job, but leaves the composer, the fill and the late gutter. | {count} undelivered visits are marked “Season over”. They stay owed and visible on their jobs, but leave the composer, the fill and the late gutter.",
        "closeUncalled": "{count} customer never called back loses their renewal campaign. | {count} customers never called back lose their renewal campaign.",
        "closeComposer": "The composer proposes nothing more for {name} {label}.",
        "closeLeadsRenew": "{count} unsold quote moves to {name} {next}: it comes back to the sales desk when that season opens. | {count} unsold quotes move to {name} {next}: they come back to the sales desk when that season opens.",
        "closeLeadsLose": "{count} unsold quote is marked lost. | {count} unsold quotes are marked lost.",
        "closeLeadsLosePaper": "{count} of them has a quote out with the customer: it dies with the deal. | {count} of them have a quote out with the customer: they die with the deal.",
        "closeLeadsKeep": "{count} unsold quote stays on {name} {label} and leaves the sales desk; its season can be changed from the job page. | {count} unsold quotes stay on {name} {label} and leave the sales desk; their season can be changed from the job page.",
        "nextOpenable": "{name} {label} can be opened afterwards, not before.",
        "reopenable": "You can reopen {name} {label} as long as {next} is not open.",
        "reopenUnserved": "{count} « Season over » visit is owed again: it returns to the composer, the fill and the overdue list. | {count} « Season over » visits are owed again: they return to the composer, the fill and the overdue list.",
        "reopenComposer": "The composer proposes for {name} {label} again, within its interval.",
        "reopenComposerStopped": "The composer stays stopped: its interval ended on {date}. Change it to restart.",
        "reopenLeads": "{count} unsold quote of {name} {label} comes back to the sales desk. | {count} unsold quotes of {name} {label} come back to the sales desk.",
        "reopenBlocksNext": "{name} {next} cannot be opened while {label} is.",
        "reopenUndo": "You can close {name} {label} again.",
        "closeStartsCampaign": "The {name} {next} renewal campaign starts. {name} {next} stays closed: nothing is planned before « Open ».",
        "openStartsCampaign": "The {name} {label} renewal campaign starts too."
      }
    }
  }
}
